import * as i0 from '@angular/core';
import { Component, Optional, Inject, Injectable, Directive, Input, HostListener, NgModule, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import * as i1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i5 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import * as i3$1 from '@angular/material/select';
import { MatSelectModule, MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i6 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i2 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import * as i1$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { getDocument, getWindow } from 'ssr-window';
import * as i4 from '@angular/material/core';
import * as i1$3 from '@angular/cdk/clipboard';
import { style, state, animate, transition, trigger } from '@angular/animations';
function CfAlertComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵelement(2, "i", 5);
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "mat-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r0.value / ctx_r0.duration * 100);
  }
}
function CfAlertComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 4);
    i0.ɵɵelement(2, "i", 9);
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "mat-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r0.value / ctx_r0.duration * 100);
  }
}
const _c0 = a0 => ({
  disabled: a0
});
function CfButtonComponent_div_1_mat_spinner_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r1.loading));
  }
}
function CfButtonComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function CfButtonComponent_div_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.raiseClickEvent($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CfButtonComponent_div_1_mat_spinner_3_Template, 1, 3, "mat-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵproperty("ngClass", ctx_r1.classes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.loading || ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
  }
}
function CfButtonComponent_div_2_mat_spinner_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r1.loading));
  }
}
function CfButtonComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "button", 10);
    i0.ɵɵlistener("click", function CfButtonComponent_div_2_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.raiseClickEvent($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CfButtonComponent_div_2_mat_spinner_3_Template, 1, 3, "mat-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵproperty("ngClass", ctx_r1.classes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.loading || ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
  }
}
function CfButtonComponent_div_3_mat_spinner_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r1.loading));
  }
}
function CfButtonComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "button", 12);
    i0.ɵɵlistener("click", function CfButtonComponent_div_3_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.raiseClickEvent($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CfButtonComponent_div_3_mat_spinner_3_Template, 1, 3, "mat-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵproperty("ngClass", ctx_r1.classes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.loading || ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
  }
}
function CfButtonComponent_div_4_mat_spinner_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r1.loading));
  }
}
function CfButtonComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "button", 14);
    i0.ɵɵlistener("click", function CfButtonComponent_div_4_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.raiseClickEvent($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CfButtonComponent_div_4_mat_spinner_3_Template, 1, 3, "mat-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵproperty("ngClass", ctx_r1.classes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.loading || ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
  }
}
const _c1 = ["*"];
const _c2 = (a0, a1) => ({
  "width": a0,
  "height": a1
});
function CfCardComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 4)(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 4)(8, "span", 7);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.theme);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.stat);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.subtitle);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.heading);
  }
}
function CfCardComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 4)(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 4)(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 4)(8, "span", 7);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.theme);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.stat);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.subtitle);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.heading);
  }
}
function CfCardComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.theme)("ngStyle", i0.ɵɵpureFunction2(2, _c2, ctx_r0.fullWidth ? "100%" : null, ctx_r0.fullHeight ? "100%" : null));
  }
}
function CfCheckboxComponent_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.control.errors[ctx_r0.objectFn.keys(ctx_r0.control.errors)[0]], " ");
  }
}
const _c3 = a0 => ({
  "flex-direction": a0
});
const _c4 = a0 => ({
  "cf-checkbox-large-item-active": a0
});
function CfCheckboxLargeComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function CfCheckboxLargeComponent_div_3_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 9);
  }
}
function CfCheckboxLargeComponent_div_3_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 10);
  }
}
function CfCheckboxLargeComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function CfCheckboxLargeComponent_div_3_Template_div_click_0_listener() {
      const option_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.changedHandled(option_r3));
    });
    i0.ɵɵtemplate(1, CfCheckboxLargeComponent_div_3_i_1_Template, 1, 0, "i", 6)(2, CfCheckboxLargeComponent_div_3_i_2_Template, 1, 0, "i", 7);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4, ctx_r0.currentSelected.value === option_r3.value));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.currentSelected == null ? null : ctx_r0.currentSelected.value) === option_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.currentSelected == null ? null : ctx_r0.currentSelected.value) !== option_r3.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", option_r3.label, "");
  }
}
const _c5 = a0 => ({
  color: a0
});
const _c6 = (a0, a1, a2) => ({
  description: a0,
  dark: a1,
  light: a2
});
function CfDropdownComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function CfDropdownComponent_mat_select_5_mat_option_4_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 14);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", item_r3.logo, i0.ɵɵsanitizeUrl)("alt", item_r3.label);
  }
}
function CfDropdownComponent_mat_select_5_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 12);
    i0.ɵɵtemplate(1, CfDropdownComponent_mat_select_5_mat_option_4_img_1_Template, 1, 2, "img", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", item_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showLogo);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.label, " ");
  }
}
function CfDropdownComponent_mat_select_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-select", 9);
    i0.ɵɵlistener("selectionChange", function CfDropdownComponent_mat_select_5_Template_mat_select_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.changeMultiDropdown($event));
    });
    i0.ɵɵelementStart(1, "mat-select-trigger")(2, "span", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, CfDropdownComponent_mat_select_5_mat_option_4_Template, 3, 3, "mat-option", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formControl", ctx_r0.control)("ngClass", ctx_r0.classes)("disabled", ctx_r0.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(6, _c5, ctx_r0.theme === "dark" ? "white" : "black"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.multiSelectText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.options);
  }
}
function CfDropdownComponent_mat_select_6_img_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 18);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.currentSelected.logo, i0.ɵɵsanitizeUrl)("alt", ctx_r0.currentSelected.label);
  }
}
function CfDropdownComponent_mat_select_6_mat_option_5_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 18);
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", item_r5.logo, i0.ɵɵsanitizeUrl)("alt", item_r5.label);
  }
}
function CfDropdownComponent_mat_select_6_mat_option_5_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5.description, " ");
  }
}
function CfDropdownComponent_mat_select_6_mat_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 19);
    i0.ɵɵtemplate(1, CfDropdownComponent_mat_select_6_mat_option_5_img_1_Template, 1, 2, "img", 16);
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CfDropdownComponent_mat_select_6_mat_option_5_span_4_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !item_r5.optionEnabled)("value", item_r5.value)("ngClass", i0.ɵɵpureFunction3(6, _c6, ctx_r0.showDescription, ctx_r0.theme === "dark", ctx_r0.theme === "light"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showLogo);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showDescription);
  }
}
function CfDropdownComponent_mat_select_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-select", 15);
    i0.ɵɵlistener("selectionChange", function CfDropdownComponent_mat_select_6_Template_mat_select_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.changeDropdown($event));
    });
    i0.ɵɵelementStart(1, "mat-select-trigger");
    i0.ɵɵtemplate(2, CfDropdownComponent_mat_select_6_img_2_Template, 1, 2, "img", 16);
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, CfDropdownComponent_mat_select_6_mat_option_5_Template, 5, 10, "mat-option", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formControl", ctx_r0.control)("panelClass", ctx_r0.classes)("disabled", ctx_r0.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showLogo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c5, ctx_r0.theme === "dark" ? "white" : "black"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currentSelected.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.options);
  }
}
function CfDropdownComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.control.errors[ctx_r0.objectFn.keys(ctx_r0.control.errors)[0]], " ");
  }
}
const _c7 = a0 => ({
  dark: a0
});
const _c8 = a0 => ["cf-overlay-input-dropdown-child-pane", a0];
function CfInputCurrencyDropdownComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function CfInputCurrencyDropdownComponent_mat_option_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15);
    i0.ɵɵelement(1, "img", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r2.logo, i0.ɵɵsanitizeUrl)("alt", item_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2.label, " ");
  }
}
function CfInputCurrencyDropdownComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.inputControl.errors[ctx_r0.objectFn.keys(ctx_r0.inputControl.errors)[0]], " ");
  }
}
function CfInputCurrencyDropdownComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.currencyControl.errors[ctx_r0.objectFn.keys(ctx_r0.currencyControl.errors)[0]], " ");
  }
}
const _c9 = (a0, a1) => [a0, a1];
function CfInputComponent_div_1_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matTooltip", ctx_r0.tooltip);
  }
}
function CfInputComponent_div_1_sup_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "sup", 12);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function CfInputComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 0);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, CfInputComponent_div_1_i_3_Template, 1, 1, "i", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CfInputComponent_div_1_sup_4_Template, 2, 0, "sup", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.theme === "dark" ? "white-label" : "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.tooltip);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showRequiredSign);
  }
}
function CfInputComponent_span_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.placeholder, " ");
  }
}
function CfInputComponent_span_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.trimmedValue, " ");
  }
}
function CfInputComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, CfInputComponent_span_3_span_1_Template, 2, 1, "span", 13)(2, CfInputComponent_span_3_span_2_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.class);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showPlaceholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.showPlaceholder);
  }
}
function CfInputComponent_input_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 15);
    i0.ɵɵlistener("keyup", function CfInputComponent_input_4_Template_input_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.keyUpHandler($event));
    })("paste", function CfInputComponent_input_4_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onPaste($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.type)("name", ctx_r0.name)("id", ctx_r0.id)("placeholder", ctx_r0.placeholder)("value", ctx_r0.trimmedValue)("formControl", ctx_r0.control)("maxlength", ctx_r0.maxLength)("minLength", ctx_r0.minLength)("precision", ctx_r0.precision)("precisionType", ctx_r0.precisionType);
  }
}
function CfInputComponent_input_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16);
    i0.ɵɵlistener("keyup", function CfInputComponent_input_5_Template_input_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.keyUpHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.showPassword ? "text" : "password")("name", ctx_r0.name)("id", ctx_r0.id)("placeholder", ctx_r0.placeholder)("value", ctx_r0.trimmedValue)("formControl", ctx_r0.control)("maxlength", ctx_r0.maxLength)("minLength", ctx_r0.minLength);
  }
}
function CfInputComponent_i_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 17);
    i0.ɵɵlistener("click", function CfInputComponent_i_6_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.copyContent());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", "Copy " + ctx_r0.label);
  }
}
function CfInputComponent_span_7_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 21);
  }
}
function CfInputComponent_span_7_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 22);
  }
}
function CfInputComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵlistener("click", function CfInputComponent_span_7_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.showPassword = !ctx_r0.showPassword);
    });
    i0.ɵɵtemplate(1, CfInputComponent_span_7_i_1_Template, 1, 0, "i", 19)(2, CfInputComponent_span_7_i_2_Template, 1, 0, "i", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showPassword);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.showPassword);
  }
}
function CfInputComponent_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.control.errors[ctx_r0.objectFn.keys(ctx_r0.control.errors)[0]], " ");
  }
}
function CfInputCurrencyComponent_i_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 11);
    i0.ɵɵlistener("click", function CfInputCurrencyComponent_i_9_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.copyContent());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", "Copy " + ctx_r1.label);
  }
}
function CfInputCurrencyComponent_span_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.control.errors[ctx_r1.objectFn.keys(ctx_r1.control.errors)[0]], " ");
  }
}
const _c10 = (a0, a1) => ({
  "step-active": a0,
  "step-complete": a1
});
function CfVerticalProgressBarComponent_div_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i_r2 + 1);
  }
}
function CfVerticalProgressBarComponent_div_1_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
  }
}
function CfVerticalProgressBarComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵlistener("click", function CfVerticalProgressBarComponent_div_1_Template_div_click_2_listener() {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeStepHandler(i_r2));
    });
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtemplate(4, CfVerticalProgressBarComponent_div_1_span_4_Template, 2, 1, "span", 6)(5, CfVerticalProgressBarComponent_div_1_i_5_Template, 1, 0, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const step_r4 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c10, i_r2 === ctx_r2.currentStep, step_r4.completed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !step_r4.completed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", step_r4.completed);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r4.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", step_r4.content, " ");
  }
}
function CfPaginatorComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function CfPaginatorComponent_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changedHandler(1));
    });
    i0.ɵɵtext(1, " First ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.theme);
  }
}
function CfPaginatorComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function CfPaginatorComponent_div_3_Template_div_click_0_listener() {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changedHandler(item_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4, " ");
  }
}
function CfPaginatorComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function CfPaginatorComponent_div_6_Template_div_click_0_listener() {
      const item_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changedHandler(item_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r6, " ");
  }
}
function CfPaginatorComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function CfPaginatorComponent_div_7_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changedHandler(ctx_r1.lastPage));
    });
    i0.ɵɵtext(1, " Last ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.theme);
  }
}
function CfMobileNumberComponent_mat_option_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 12);
    i0.ɵɵelement(1, "img", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", item_r1)("disabled", ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r1.flagUrl, i0.ɵɵsanitizeUrl)("alt", item_r1.countryName);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r1.countryName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", item_r1.dialCode, ")");
  }
}
function CfMobileNumberComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentSelected.dialCode, " ");
  }
}
function CfMobileNumberComponent_span_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.mobileNumber, " ");
  }
}
function CfMobileNumberComponent_input_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16);
    i0.ɵɵlistener("keyup", function CfMobileNumberComponent_input_13_Template_input_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.name)("id", ctx_r1.id)("value", ctx_r1.mobileNumber)("placeholder", ctx_r1.placeholder)("formControl", ctx_r1.inputControl)("minLength", ctx_r1.minLength)("maxlength", ctx_r1.maxLength);
  }
}
function CfMobileNumberComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.inputControl.errors[ctx_r1.objectFn.keys(ctx_r1.inputControl.errors)[0]], " ");
  }
}
function CfMobileNumberComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dialCodeControl.errors[ctx_r1.objectFn.keys(ctx_r1.dialCodeControl.errors)[0]], " ");
  }
}
const _c11 = (a0, a1, a2) => ({
  "autofocus": a0,
  dark: a1,
  light: a2
});
function CfOtpComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "label", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function CfOtpComponent_div_4_input_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 11);
    i0.ɵɵlistener("keydown", function CfOtpComponent_div_4_input_1_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const i_r3 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleKeyDown($event, i_r3));
    })("keyup", function CfOtpComponent_div_4_input_1_Template_input_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const i_r3 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleKeyUp($event, i_r3));
    })("paste", function CfOtpComponent_div_4_input_1_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const i_r3 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handlePaste($event, i_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r3 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("autofocus", ctx_r0.focus[i_r3])("ngClass", i0.ɵɵpureFunction3(3, _c11, ctx_r0.focus[i_r3], ctx_r0.theme === "dark", ctx_r0.theme === "light"))("id", "cf-otp-input-web-" + i_r3);
  }
}
function CfOtpComponent_div_4_input_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 12);
    i0.ɵɵlistener("keydown", function CfOtpComponent_div_4_input_2_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r3 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleKeyDown($event, i_r3));
    })("keyup", function CfOtpComponent_div_4_input_2_Template_input_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r3 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleKeyUp($event, i_r3));
    })("paste", function CfOtpComponent_div_4_input_2_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r3 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handlePaste($event, i_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r3 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("autofocus", ctx_r0.focus[i_r3])("ngClass", i0.ɵɵpureFunction3(4, _c11, ctx_r0.focus[i_r3], ctx_r0.theme === "dark", ctx_r0.theme === "light"))("id", "cf-otp-input-mobile-" + i_r3)("value", ctx_r0.otp[i_r3]);
  }
}
function CfOtpComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, CfOtpComponent_div_4_input_1_Template, 1, 7, "input", 9)(2, CfOtpComponent_div_4_input_2_Template, 1, 8, "input", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.platform === "web");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.platform === "mobile");
  }
}
const _c12 = a0 => ({
  "font-size": a0
});
const _c13 = a0 => ({
  "tab-active": a0
});
function CfTabsComponent_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵlistener("click", function CfTabsComponent_span_2_Template_span_click_0_listener() {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeTab(tab_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c13, ctx_r2.currentTab === tab_r2.value));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r2.label);
  }
}
let CfAlertComponent = /*#__PURE__*/(() => {
  class CfAlertComponent {
    dialogRef;
    data;
    message = '';
    type = 'error';
    value = 0;
    duration = 0;
    timerId;
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.message = data.message;
      this.duration = data.duration;
      this.type = data.type;
    }
    ngOnInit() {
      const stepperDuration = 250;
      this.timerId = setInterval(() => {
        this.value += stepperDuration;
        if (this.value >= this.duration) clearInterval(this.timerId);
      }, stepperDuration);
    }
    static ɵfac = function CfAlertComponent_Factory(t) {
      return new (t || CfAlertComponent)(i0.ɵɵdirectiveInject(i1.MatSnackBarRef), i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA, 8));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfAlertComponent,
      selectors: [["cf-alert"]],
      decls: 3,
      vars: 2,
      consts: [[1, "cf-alert"], ["class", "error", 4, "ngIf"], ["class", "success", 4, "ngIf"], [1, "error"], [1, "message-holder"], [1, "fa-solid", "fa-circle-xmark"], [1, "message"], ["mode", "determinate", "diameter", "20", 3, "value"], [1, "success"], [1, "fa-solid", "fa-circle-check"]],
      template: function CfAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CfAlertComponent_div_1_Template, 6, 2, "div", 1)(2, CfAlertComponent_div_2_Template, 6, 2, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "error");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "success");
        }
      },
      dependencies: [i1$1.NgIf, i3.MatProgressSpinner],
      styles: [".cf-alert[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.cf-alert[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]   .message-holder[_ngcontent-%COMP%]   .fa-circle-xmark[_ngcontent-%COMP%]{color:red;margin-right:.5rem}.cf-alert[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]   .message-holder[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{color:red;font-weight:700}.cf-alert[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.cf-alert[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]   .message-holder[_ngcontent-%COMP%]   .fa-circle-check[_ngcontent-%COMP%]{color:#90ee90;margin-right:.5rem}.cf-alert[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]   .message-holder[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{color:#90ee90;font-weight:700}  .cf-alert .error .mat-progress-spinner circle, .cf-alert[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]   .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:red}  .cf-alert .success .mat-progress-spinner circle, .cf-alert[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]   .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#90ee90}"]
    });
  }
  return CfAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfAlertService = /*#__PURE__*/(() => {
  class CfAlertService {
    _snackBar;
    duration = 5 * 1000;
    horizontalPosition = 'center';
    verticalPosition = 'top';
    constructor(_snackBar) {
      this._snackBar = _snackBar;
    }
    showError(err) {
      let message = 'Something went wrong';
      if (err && err.error && err.error.message) message = err.error.message;
      this._snackBar.openFromComponent(CfAlertComponent, {
        duration: this.duration,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        data: {
          message: message,
          type: 'error',
          duration: this.duration
        }
      });
    }
    showMessage(message, error = false) {
      this._snackBar.openFromComponent(CfAlertComponent, {
        duration: this.duration,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        data: {
          message: message,
          type: error ? 'error' : 'success',
          duration: this.duration
        }
      });
    }
    showSuccess(message) {
      this._snackBar.openFromComponent(CfAlertComponent, {
        duration: this.duration,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        data: {
          message: message,
          type: 'success',
          duration: this.duration
        }
      });
    }
    static ɵfac = function CfAlertService_Factory(t) {
      return new (t || CfAlertService)(i0.ɵɵinject(i1.MatSnackBar));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CfAlertService,
      factory: CfAlertService.ɵfac,
      providedIn: 'root'
    });
  }
  return CfAlertService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PrecisionDirective = /*#__PURE__*/(() => {
  class PrecisionDirective {
    el;
    precision = 0;
    type = 'text';
    precisionType = '';
    allowedKeys = new Set();
    constructor(el) {
      this.el = el;
      const allowedKeys = ['Backspace', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', '.', 'Meta', 'v'];
      this.allowedKeys = new Set(allowedKeys);
    }
    onPaste(event) {
      const clipboardData = event.clipboardData;
      const pastedText = clipboardData?.getData('text');
      if (this.type === 'number' && pastedText?.length > 0) {
        if (Number(pastedText)) return true;else {
          this.el.nativeElement.value = '';
          return false;
        }
      }
      return true;
    }
    onKeyDown(event) {
      const value = this.el.nativeElement.value;
      const regex = new RegExp(/[0-9]/);
      if (this.type === 'number') {
        const allowed = this.allowedKeys.has(event.key);
        if (!allowed) return false;
        if (event.code === 'Space') event.preventDefault();
        if (event.key === '.' && value.toString().indexOf('.') !== -1) return false;
        if (this.precisionType === 'decimal') {
          if (regex.test(event.key)) {
            if (value.toString().includes('.')) {
              const str = value.toString().split('.');
              if (str[1].length >= this.precision) return false;
            }
          }
        } else if (this.precisionType === 'input') {
          if (event.code === 'Period') event.preventDefault();
          if (event.code === 'Space') event.preventDefault();
          if (!this.optionalKeys(event)) {
            if (value.length >= this.precision) return false;
          }
        }
      }
      return true;
    }
    optionalKeys(event) {
      if (event.code === 'Backspace') return true;
      if (event.code === 'ArrowLeft') return true;
      if (event.code === 'ArrowRight') return true;
      if (event.code === 'ArrowUp') return true;
      if (event.code === 'ArrowDown') return true;
      return false;
    }
    static ɵfac = function PrecisionDirective_Factory(t) {
      return new (t || PrecisionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PrecisionDirective,
      selectors: [["", "PrecisionDirective", ""]],
      hostBindings: function PrecisionDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("paste", function PrecisionDirective_paste_HostBindingHandler($event) {
            return ctx.onPaste($event);
          })("keydown", function PrecisionDirective_keydown_HostBindingHandler($event) {
            return ctx.onKeyDown($event);
          });
        }
      },
      inputs: {
        precision: "precision",
        type: "type",
        precisionType: "precisionType"
      }
    });
  }
  return PrecisionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedModule = /*#__PURE__*/(() => {
  class SharedModule {
    static ɵfac = function SharedModule_Factory(t) {
      return new (t || SharedModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SharedModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatCheckboxModule, MatTooltipModule, MatProgressSpinnerModule, MatSnackBarModule, MatSlideToggleModule, MatStepperModule, MatProgressBarModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatCheckboxModule, MatTooltipModule, MatProgressSpinnerModule, MatSnackBarModule, MatSlideToggleModule, MatStepperModule, MatProgressBarModule]
    });
  }
  return SharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfAlertModule = /*#__PURE__*/(() => {
  class CfAlertModule {
    static ɵfac = function CfAlertModule_Factory(t) {
      return new (t || CfAlertModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfAlertModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [CfAlertService, {
        provide: MatSnackBarRef,
        useValue: {}
      }],
      imports: [CommonModule, SharedModule]
    });
  }
  return CfAlertModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfButtonComponent = /*#__PURE__*/(() => {
  class CfButtonComponent {
    label = '';
    type = 'solid';
    clicked = new EventEmitter();
    loading = false;
    disabled = false;
    align = 'center';
    theme = 'dark';
    constructor() {}
    raiseClickEvent($event) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
      $event.stopPropagation();
      this.clicked.emit();
    }
    get classes() {
      if (this.disabled) return ['disabled', `button-${this.align}`, this.theme];else return [`button-${this.align}`, this.theme];
    }
    static ɵfac = function CfButtonComponent_Factory(t) {
      return new (t || CfButtonComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfButtonComponent,
      selectors: [["cf-button"]],
      inputs: {
        label: "label",
        type: "type",
        loading: "loading",
        disabled: "disabled",
        align: "align",
        theme: "theme"
      },
      outputs: {
        clicked: "clicked"
      },
      decls: 5,
      vars: 4,
      consts: [[1, "cf-button"], ["class", "cf-button-solid", 3, "ngClass", "disabled", 4, "ngIf"], ["class", "cf-button-theme", 3, "ngClass", "disabled", 4, "ngIf"], ["class", "cf-button-outline", 3, "ngClass", "disabled", 4, "ngIf"], ["class", "cf-button-text", 3, "ngClass", "disabled", 4, "ngIf"], [1, "cf-button-solid", 3, "ngClass"], [1, "solid", 3, "click", "disabled"], ["mode", "indeterminate", "diameter", "20", "class", "loader d-flex", 3, "ngClass", 4, "ngIf"], ["mode", "indeterminate", "diameter", "20", 1, "loader", "d-flex", 3, "ngClass"], [1, "cf-button-theme", 3, "ngClass"], [1, "theme", 3, "click", "disabled"], [1, "cf-button-outline", 3, "ngClass"], [1, "outline", 3, "click", "disabled"], [1, "cf-button-text", 3, "ngClass"], [1, "text", 3, "click", "disabled"]],
      template: function CfButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CfButtonComponent_div_1_Template, 4, 6, "div", 1)(2, CfButtonComponent_div_2_Template, 4, 6, "div", 2)(3, CfButtonComponent_div_3_Template, 4, 6, "div", 3)(4, CfButtonComponent_div_4_Template, 4, 6, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "solid");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "theme");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "outline");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "text");
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i3.MatProgressSpinner],
      styles: [".cf-button[_ngcontent-%COMP%]{line-height:normal}.cf-button[_ngcontent-%COMP%]   .button-left[_ngcontent-%COMP%]{margin-right:auto}.cf-button[_ngcontent-%COMP%]   .button-right[_ngcontent-%COMP%]{margin-left:auto}.cf-button[_ngcontent-%COMP%]   .button-center[_ngcontent-%COMP%]{margin:auto}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.disabled[_ngcontent-%COMP%], .cf-button[_ngcontent-%COMP%]   .cf-button-theme.disabled[_ngcontent-%COMP%]{background:#0C0C0C!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.disabled[_ngcontent-%COMP%], .cf-button[_ngcontent-%COMP%]   .cf-button-text.disabled[_ngcontent-%COMP%]{background:rgba(0,0,0,.1)}.cf-button[_ngcontent-%COMP%]   .cf-button-solid[_ngcontent-%COMP%]{display:flex;width:max-content;border-radius:9px}.cf-button[_ngcontent-%COMP%]   .cf-button-solid[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]{padding:12px 1.5rem;border-radius:inherit}.cf-button[_ngcontent-%COMP%]   .cf-button-solid[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-solid[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]:hover:not(:disabled){cursor:pointer}.cf-button[_ngcontent-%COMP%]   .cf-button-solid[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{margin:4px 4px 0 0;align-self:center}.cf-button[_ngcontent-%COMP%]   .cf-button-solid[_ngcontent-%COMP%]   .loader.disabled[_ngcontent-%COMP%]{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.dark[_ngcontent-%COMP%]{background:white!important}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.dark[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]{color:#000!important;background-color:transparent;border:none}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.dark[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]:disabled{color:gray!important}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.dark[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]:hover:not(:disabled){color:#000!important;background-color:#cf0!important;border:.5px solid #cf0}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.light[_ngcontent-%COMP%]{background:black!important}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.light[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]{color:#fff!important;background-color:transparent;border:1px solid black}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.light[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]:disabled{color:gray!important}.cf-button[_ngcontent-%COMP%]   .cf-button-solid.light[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%]:hover:not(:disabled){color:#000!important;background-color:#cf0!important;border:.5px solid #cf0}.cf-button[_ngcontent-%COMP%]   .cf-button-theme[_ngcontent-%COMP%]{display:flex;width:max-content;border-radius:9px}.cf-button[_ngcontent-%COMP%]   .cf-button-theme[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]{padding:12px 1.5rem;border-radius:inherit}.cf-button[_ngcontent-%COMP%]   .cf-button-theme[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-theme[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]:hover:not(:disabled){cursor:pointer}.cf-button[_ngcontent-%COMP%]   .cf-button-theme[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{margin:4px 4px 0 0;align-self:center}.cf-button[_ngcontent-%COMP%]   .cf-button-theme[_ngcontent-%COMP%]   .loader.disabled[_ngcontent-%COMP%]{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.dark[_ngcontent-%COMP%]{background:#cf0!important}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.dark[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]{color:#000!important;background-color:transparent;border:none}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.dark[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]:disabled{color:gray!important}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.dark[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]:hover:not(:disabled){color:#000!important;background-color:#fff!important;border:.5px solid white}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.light[_ngcontent-%COMP%]{background:#cf0!important}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.light[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]{color:#000!important;background-color:transparent;border:none}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.light[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]:disabled{color:gray!important}.cf-button[_ngcontent-%COMP%]   .cf-button-theme.light[_ngcontent-%COMP%]   .theme[_ngcontent-%COMP%]:hover:not(:disabled){color:#000!important;background-color:#fff!important;border:1px solid #cf0}.cf-button[_ngcontent-%COMP%]   .cf-button-outline[_ngcontent-%COMP%]{display:flex;width:max-content;border-radius:9px}.cf-button[_ngcontent-%COMP%]   .cf-button-outline[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]{padding:12px 1.5rem;border-radius:inherit}.cf-button[_ngcontent-%COMP%]   .cf-button-outline[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]:disabled{cursor:not-allowed;opacity:.5}.cf-button[_ngcontent-%COMP%]   .cf-button-outline[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]:hover:not(:disabled){cursor:pointer}.cf-button[_ngcontent-%COMP%]   .cf-button-outline[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{margin:4px 4px 0 0;align-self:center}.cf-button[_ngcontent-%COMP%]   .cf-button-outline[_ngcontent-%COMP%]   .loader.disabled[_ngcontent-%COMP%]{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.dark[_ngcontent-%COMP%]{border:.5px solid rgb(125,125,125)!important;background:#1c1c1c!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.dark[_ngcontent-%COMP%]:hover:not(.disabled){border:.5px solid #cf0!important;background-color:#cf0!important;color:#000!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.dark[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]{color:#fff!important;border:none;background-color:transparent}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.dark[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]:disabled{background-color:transparent!important;color:inherit!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.dark[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]:hover:not([disabled]){color:#000!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.light[_ngcontent-%COMP%]{border:.1px solid #f5f5f5!important;background:transparent!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.light[_ngcontent-%COMP%]:hover:not(.disabled){background-color:#cf0!important;color:#000!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.light[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]{color:#000!important;border:none;background-color:transparent;border-radius:inherit}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.light[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]:disabled{background-color:transparent!important;color:inherit!important}.cf-button[_ngcontent-%COMP%]   .cf-button-outline.light[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%]:hover:not([disabled]){border:.1px solid black}.cf-button[_ngcontent-%COMP%]   .cf-button-text[_ngcontent-%COMP%]{display:flex;width:max-content;border-radius:9px}.cf-button[_ngcontent-%COMP%]   .cf-button-text[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{padding:12px 1.5rem;font-weight:700;border-radius:inherit}.cf-button[_ngcontent-%COMP%]   .cf-button-text[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-text[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]:hover:not(:disabled){cursor:pointer}.cf-button[_ngcontent-%COMP%]   .cf-button-text[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{margin:4px 4px 0 0;align-self:center}.cf-button[_ngcontent-%COMP%]   .cf-button-text[_ngcontent-%COMP%]   .loader.disabled[_ngcontent-%COMP%]{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-text.dark[_ngcontent-%COMP%]{background:transparent}.cf-button[_ngcontent-%COMP%]   .cf-button-text.dark[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#d3d3d3;background-color:transparent;border:none}.cf-button[_ngcontent-%COMP%]   .cf-button-text.dark[_ngcontent-%COMP%]:hover{border:.1px solid #f5f5f5}.cf-button[_ngcontent-%COMP%]   .cf-button-text.dark[_ngcontent-%COMP%]:hover   .text[_ngcontent-%COMP%]{color:#fff}.cf-button[_ngcontent-%COMP%]   .cf-button-text.light[_ngcontent-%COMP%]{background:transparent;border-radius:9px}.cf-button[_ngcontent-%COMP%]   .cf-button-text.light[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#000;background-color:transparent;border:none}.cf-button[_ngcontent-%COMP%]   .cf-button-text.light[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.cf-button[_ngcontent-%COMP%]   .cf-button-text.light[_ngcontent-%COMP%]:hover{border:.1px solid #f5f5f5}  .cf-button .mdc-circular-progress__circle-left svg{stroke:#cf0}  .cf-button .mdc-circular-progress__gap-patch svg{stroke:#cf0}  .cf-button .mdc-circular-progress__circle-right svg{stroke:#000}@media only screen and (max-width: 500px){button[_ngcontent-%COMP%]{font-size:1rem!important}.cf-button-solid[_ngcontent-%COMP%]   .solid[_ngcontent-%COMP%], .cf-button-outline[_ngcontent-%COMP%]   .outline[_ngcontent-%COMP%], .cf-button-text[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{padding:.5rem 1rem!important}}"]
    });
  }
  return CfButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfButtonModule = /*#__PURE__*/(() => {
  class CfButtonModule {
    static ɵfac = function CfButtonModule_Factory(t) {
      return new (t || CfButtonModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfButtonModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCardComponent = /*#__PURE__*/(() => {
  class CfCardComponent {
    stat = '';
    subtitle = '';
    heading = '';
    type = 'large';
    theme = 'dark';
    fullWidth = false;
    fullHeight = false;
    constructor() {}
    static ɵfac = function CfCardComponent_Factory(t) {
      return new (t || CfCardComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfCardComponent,
      selectors: [["cf-card"]],
      inputs: {
        stat: "stat",
        subtitle: "subtitle",
        heading: "heading",
        type: "type",
        theme: "theme",
        fullWidth: "fullWidth",
        fullHeight: "fullHeight"
      },
      ngContentSelectors: _c1,
      decls: 3,
      vars: 3,
      consts: [["class", "container-fluid cf-card-large", 3, "ngClass", 4, "ngIf"], ["class", "container-fluid cf-card-compact", 3, "ngClass", 4, "ngIf"], ["class", "container-fluid cf-card-large", 3, "ngClass", "ngStyle", 4, "ngIf"], [1, "container-fluid", "cf-card-large", 3, "ngClass"], [1, "row"], [1, "stat"], [1, "subtitle"], [1, "heading"], [1, "container-fluid", "cf-card-compact", 3, "ngClass"], [1, "container-fluid", "cf-card-large", 3, "ngClass", "ngStyle"]],
      template: function CfCardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, CfCardComponent_div_0_Template, 10, 4, "div", 0)(1, CfCardComponent_div_1_Template, 10, 4, "div", 1)(2, CfCardComponent_div_2_Template, 2, 5, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.type === "large");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "compact");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "empty");
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i1$1.NgStyle],
      styles: [".cf-card-large[_ngcontent-%COMP%]{display:grid;padding:1rem;border-radius:9px;height:max-content;display:block}.cf-card-large[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{font-size:2rem;text-align:center}.cf-card-large[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{font-size:1.2rem;margin-top:.8rem;text-align:center}.cf-card-large[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{font-size:.8rem;margin-top:1rem;text-align:center}.cf-card-large.dark[_ngcontent-%COMP%]{background:#1D1E22;box-shadow:0 1px 9px -6px gray}.cf-card-large.dark[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{color:#fff}.cf-card-large.dark[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%], .cf-card-large.dark[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{color:gray}.cf-card-large.light[_ngcontent-%COMP%]{background:white;box-shadow:0 1px 9px -6px gray}.cf-card-large.light[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{color:#000}.cf-card-large.light[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:gray}.cf-card-large.light[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{color:#000}.cf-card-compact[_ngcontent-%COMP%]{display:grid;border-radius:9px;padding:1rem;box-shadow:0 1px 9px -6px gray;background:#1D1E22}.cf-card-compact[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{font-size:1.5rem;color:#fff;text-align:center}.cf-card-compact[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{font-size:1rem;margin-top:.3rem;text-align:center}.cf-card-compact[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{font-size:.8rem;margin-top:.3rem;text-align:center}.cf-card-compact.dark[_ngcontent-%COMP%]{background:#1D1E22;box-shadow:0 1px 9px -6px gray}.cf-card-compact.dark[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{color:#fff}.cf-card-compact.dark[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%], .cf-card-compact.dark[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{color:gray}.cf-card-compact.light[_ngcontent-%COMP%]{background:white;box-shadow:0 1px 9px -6px gray}.cf-card-compact.light[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{color:#000}.cf-card-compact.light[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:gray}.cf-card-compact.light[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{color:#000}"]
    });
  }
  return CfCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCardModule = /*#__PURE__*/(() => {
  class CfCardModule {
    static ɵfac = function CfCardModule_Factory(t) {
      return new (t || CfCardModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfCardModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfCardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCheckboxComponent = /*#__PURE__*/(() => {
  class CfCheckboxComponent {
    name = '';
    id = '';
    disabled = false;
    checked = false;
    readonly = false;
    theme = 'dark';
    changed = new EventEmitter();
    formGroup;
    control;
    // HTML helpers
    objectFn = Object;
    constructor() {
      if (!this.control && !this.formGroup) {
        this.formGroup = new FormGroup({});
        this.control = new FormControl('');
        this.control.setValue(this.checked);
      }
    }
    ngOnInit() {}
    ngOnChanges(changes) {
      if (changes.checked) this.control.setValue(this.checked);
    }
    changeHandler(event) {
      this.changed.emit(event.currentTarget.checked);
    }
    static ɵfac = function CfCheckboxComponent_Factory(t) {
      return new (t || CfCheckboxComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfCheckboxComponent,
      selectors: [["cf-checkbox"]],
      inputs: {
        name: "name",
        id: "id",
        disabled: "disabled",
        checked: "checked",
        readonly: "readonly",
        theme: "theme",
        formGroup: "formGroup",
        control: "control"
      },
      outputs: {
        changed: "changed"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 9,
      consts: [[3, "ngClass"], [1, "container-fluid"], [1, "row"], [1, "col-md-12", 3, "formGroup"], [1, "cf-container", 3, "ngClass"], ["type", "checkbox", 3, "change", "checked", "readonly", "disabled", "id"], [1, "checkmark"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"]],
      template: function CfCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "label", 4);
          i0.ɵɵtext(5);
          i0.ɵɵelementStart(6, "input", 5);
          i0.ɵɵlistener("change", function CfCheckboxComponent_Template_input_change_6_listener($event) {
            return ctx.changeHandler($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "span", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(8, CfCheckboxComponent_span_8_Template, 2, 1, "span", 7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.control.invalid && ctx.control.touched ? "cf-checkbox mb-0" : "cf-checkbox");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1("", ctx.name, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("checked", ctx.checked ? "checked" : null)("readonly", ctx.readonly)("disabled", ctx.disabled)("id", ctx.id);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.control.errors && ctx.control.touched);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective],
      styles: [".cf-checkbox[_ngcontent-%COMP%]{width:max-content;margin:auto;font-family:inherit}.cf-container[_ngcontent-%COMP%]{display:block;position:relative;padding-left:35px;margin-bottom:12px;cursor:pointer;-webkit-user-select:none;user-select:none;font-size:1rem;font-weight:400}.cf-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.cf-container[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]{position:absolute;top:0;left:0;height:25px;width:25px;border-radius:2px}.cf-container.dark[_ngcontent-%COMP%]:hover   input[_ngcontent-%COMP%] ~ .checkmark[_ngcontent-%COMP%]{background-color:#1d1e22}.cf-container.light[_ngcontent-%COMP%]:hover   input[_ngcontent-%COMP%] ~ .checkmark[_ngcontent-%COMP%]{background-color:#fff}.cf-container.dark[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]{color:#cf0}.cf-container.light[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]{color:#cf0}.checkmark[_ngcontent-%COMP%]:after{content:\"\";position:absolute;display:none}.cf-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]:after{display:block}.cf-container[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]:after{left:8px;top:3px;width:7px;height:13px;border-style:solid;border-width:0 3px 3px 0;transform:rotate(45deg)}.cf-container.dark[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]:after{border-color:#fff}.cf-container.light[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]:after{border-color:#000}.error[_ngcontent-%COMP%]     .mat-checkbox-layout .mat-checkbox-frame{border-color:#dc3545}.cf-container.dark[_ngcontent-%COMP%]{color:gray}.cf-container.dark[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]{border:.1px solid grey;background-color:transparent}.cf-container.light[_ngcontent-%COMP%]{color:#000}.cf-container.light[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]{border:.1px solid #f5f5f5;background-color:transparent}@media only screen and (max-width: 500px){.cf-checkbox[_ngcontent-%COMP%]{font-size:1rem!important}}"]
    });
  }
  return CfCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCheckboxModule = /*#__PURE__*/(() => {
  class CfCheckboxModule {
    static ɵfac = function CfCheckboxModule_Factory(t) {
      return new (t || CfCheckboxModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfCheckboxModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfCheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class checkbox {
  label = '';
  value = '';
  optionEnabled = true;
}
let CfCheckboxLargeComponent = /*#__PURE__*/(() => {
  class CfCheckboxLargeComponent {
    options = [];
    disabled = false;
    theme = 'dark';
    layout = 'flex';
    changed = new EventEmitter();
    selected = '';
    showLabel = true;
    label = '';
    currentSelected = new checkbox();
    changedHandled(option) {
      const currentSelected = this.getCurrentSelectedOption(option.value);
      if (currentSelected) {
        this.currentSelected = currentSelected;
        this.changed.emit(this.currentSelected);
      }
    }
    ngOnChanges(changes) {
      if (changes['selected']?.currentValue) {
        this.selected = changes['selected'].currentValue;
        if (this.options.length > 0) this.setDefaultSingleSelection();
      }
      if (changes['options']?.currentValue.length > 0) {
        this.setDefaultSingleSelection();
      }
    }
    setDefaultSingleSelection() {
      if (typeof this.selected === 'string') {
        const index = this.validOption(this.selected);
        if (index === -1) this.currentSelected = this.options[0];else this.currentSelected = this.options[index];
      } else this.currentSelected = this.options[0];
    }
    getCurrentSelectedOption(value) {
      return this.options.find(x => x.value === value);
    }
    validOption(value) {
      if (value === '') return -1;
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value) return i;
      }
      return -1;
    }
    static ɵfac = function CfCheckboxLargeComponent_Factory(t) {
      return new (t || CfCheckboxLargeComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfCheckboxLargeComponent,
      selectors: [["cf-checkbox-large"]],
      inputs: {
        options: "options",
        disabled: "disabled",
        theme: "theme",
        layout: "layout",
        selected: "selected",
        showLabel: "showLabel",
        label: "label"
      },
      outputs: {
        changed: "changed"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 6,
      consts: [[1, "cf-checkbox-large", 3, "ngClass"], [4, "ngIf"], [1, "checkbox-content", 3, "ngStyle"], ["class", "cf-checkbox-large-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "label"], [1, "cf-checkbox-large-item", 3, "click", "ngClass"], ["class", "fa-regular fa-circle-check", 4, "ngIf"], ["class", "fa-regular fa-circle", 4, "ngIf"], [1, "item-label"], [1, "fa-regular", "fa-circle-check"], [1, "fa-regular", "fa-circle"]],
      template: function CfCheckboxLargeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CfCheckboxLargeComponent_div_1_Template, 3, 1, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, CfCheckboxLargeComponent_div_3_Template, 5, 6, "div", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c3, ctx.layout === "flex" ? "row" : "column"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.options);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgStyle],
      styles: [".cf-checkbox-large[_ngcontent-%COMP%]{padding:0!important;height:max-content;margin-left:auto;margin-right:auto}.cf-checkbox-large[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;font-size:.8rem;margin-bottom:3px}.cf-checkbox-large[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]{display:flex;gap:1rem}.cf-checkbox-large[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]{align-items:center;gap:.5rem;padding:1rem;border-radius:9px}.cf-checkbox-large[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]:hover{background:#F5F5F5;cursor:pointer}.cf-checkbox-large[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .fa-circle-check[_ngcontent-%COMP%], .cf-checkbox-large[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .fa-circle[_ngcontent-%COMP%]{font-size:1.2rem}.cf-checkbox-large.dark[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#fff}.cf-checkbox-large.dark[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]{background:#24252B;border:.5px solid grey}.cf-checkbox-large.dark[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .item-label[_ngcontent-%COMP%]{color:gray}.cf-checkbox-large.dark[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .fa-circle-check[_ngcontent-%COMP%], .cf-checkbox-large.dark[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .fa-circle[_ngcontent-%COMP%]{color:#d3d3d3}.cf-checkbox-large.dark[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item-active[_ngcontent-%COMP%]{border:1px solid lightgrey}.cf-checkbox-large.dark[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item-active[_ngcontent-%COMP%]   .item-label[_ngcontent-%COMP%]{color:#d3d3d3}.cf-checkbox-large.light[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#000}.cf-checkbox-large.light[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]{background:white;border:.5px solid grey}.cf-checkbox-large.light[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .item-label[_ngcontent-%COMP%], .cf-checkbox-large.light[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .fa-circle-check[_ngcontent-%COMP%], .cf-checkbox-large.light[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item[_ngcontent-%COMP%]   .fa-circle[_ngcontent-%COMP%]{color:gray}.cf-checkbox-large.light[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item-active[_ngcontent-%COMP%]{border:1px solid black}.cf-checkbox-large.light[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]   .cf-checkbox-large-item-active[_ngcontent-%COMP%]   .item-label[_ngcontent-%COMP%]{color:#000}@media only screen and (max-width: 500px){.cf-checkbox-large[_ngcontent-%COMP%]   .checkbox-content[_ngcontent-%COMP%]{grid-template-columns:1fr!important}}"]
    });
  }
  return CfCheckboxLargeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCheckboxLargeModule = /*#__PURE__*/(() => {
  class CfCheckboxLargeModule {
    static ɵfac = function CfCheckboxLargeModule_Factory(t) {
      return new (t || CfCheckboxLargeModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfCheckboxLargeModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfCheckboxLargeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfChipComponent = /*#__PURE__*/(() => {
  class CfChipComponent {
    label = '';
    theme = 'dark';
    constructor() {}
    static ɵfac = function CfChipComponent_Factory(t) {
      return new (t || CfChipComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfChipComponent,
      selectors: [["cf-chip"]],
      inputs: {
        label: "label",
        theme: "theme"
      },
      decls: 3,
      vars: 1,
      consts: [[1, "cf-chip"]],
      template: function CfChipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "span");
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.label);
        }
      },
      styles: [".cf-chip[_ngcontent-%COMP%]{width:max-content}.cf-chip[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-color:#d3d3d3;border-radius:1rem;padding:4px 8px;color:#000000b3}"]
    });
  }
  return CfChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfChipModule = /*#__PURE__*/(() => {
  class CfChipModule {
    static ɵfac = function CfChipModule_Factory(t) {
      return new (t || CfChipModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfChipModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfChipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfProgressBarComponent = /*#__PURE__*/(() => {
  class CfProgressBarComponent {
    mode = 'indeterminate';
    value = 0;
    constructor() {}
    static ɵfac = function CfProgressBarComponent_Factory(t) {
      return new (t || CfProgressBarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfProgressBarComponent,
      selectors: [["cf-progress-bar"]],
      inputs: {
        mode: "mode",
        value: "value"
      },
      decls: 2,
      vars: 1,
      consts: [[1, "cf-progress-bar"], [3, "mode"]],
      template: function CfProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "mat-progress-bar", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("mode", ctx.mode);
        }
      },
      dependencies: [i1$2.MatProgressBar],
      styles: [".mat-progress-bar-fill:after{background-color:#24252b}"]
    });
  }
  return CfProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfProgressBarModule = /*#__PURE__*/(() => {
  class CfProgressBarModule {
    static ɵfac = function CfProgressBarModule_Factory(t) {
      return new (t || CfProgressBarModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfProgressBarModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfProgressBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCircularTimerProgressComponent = /*#__PURE__*/(() => {
  class CfCircularTimerProgressComponent {
    expiry = 0;
    theme = 'dark';
    timer = 0;
    hours = 0;
    mins = 0;
    secs = 0;
    timerId;
    timerString = '00:00';
    animationClass = {};
    constructor() {}
    ngOnChanges(changes) {
      if (changes['expiry']) {
        const currentValue = changes['expiry'].currentValue;
        if (currentValue) this.expiryChanged();
      }
    }
    ngOnDestroy() {
      this.clearInterval();
    }
    expiryChanged() {
      this.clearInterval();
      this.timer = (this.expiry - new Date().getTime()) / 1000;
      this.animationClass['animation-duration'] = this.timer + 's';
      this.timerId = setInterval(() => {
        if (this.timer > 1) this.timer--;
        this.formatTime();
        if (this.timer === 0) this.clearInterval();
      }, 1000);
    }
    clearInterval() {
      if (this.timerId) clearInterval(this.timerId);
    }
    formatTime() {
      if (this.timer > 60 * 60) this.hours = this.timer / (60 * 60);
      this.mins = Math.floor(this.timer / 60);
      this.secs = Math.floor(this.timer - this.mins * 60);
      let timerString = '';
      if (this.hours > 0) timerString = this.hours < 10 ? `0${this.hours}:` : `${this.hours}:`;
      timerString += this.mins < 10 ? `0${this.mins}:` : `${this.mins}:`;
      timerString += this.secs < 10 ? `0${this.secs}` : `${this.secs}`;
      this.timerString = timerString;
    }
    static ɵfac = function CfCircularTimerProgressComponent_Factory(t) {
      return new (t || CfCircularTimerProgressComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfCircularTimerProgressComponent,
      selectors: [["cf-circular-timer-progress"]],
      inputs: {
        expiry: "expiry",
        theme: "theme"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 4,
      consts: [[1, "outside-circle", 3, "ngStyle", "ngClass"], [1, "inside-circle", 3, "ngClass"], [1, "blinking-text"]],
      template: function CfCircularTimerProgressComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngStyle", ctx.animationClass)("ngClass", ctx.theme);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1("", ctx.timerString, " ");
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgStyle],
      styles: ["@property --percent{syntax: \"<angle>\"; inherits: false; initial-value: 360deg;}.outside-circle[_ngcontent-%COMP%]{height:100%;width:100%;border-radius:50%;align-items:center;display:grid;animation-name:_ngcontent-%COMP%_rotate;animation-timing-function:ease-in-out}.outside-circle.dark[_ngcontent-%COMP%]{background-image:conic-gradient(black 0deg var(--percent),#cf0 var(--percent))}.outside-circle.light[_ngcontent-%COMP%]{background-image:conic-gradient(white 0deg var(--percent),#cf0 var(--percent))}.inside-circle[_ngcontent-%COMP%]{width:80%;height:80%;border-radius:50%;margin:auto;display:grid;align-items:center;text-align:center;font-size:2rem}.inside-circle.dark[_ngcontent-%COMP%]{background:#17181C;color:#cf0}.inside-circle.light[_ngcontent-%COMP%]{background:white;color:#cf0}@keyframes _ngcontent-%COMP%_blink{0%{opacity:1}50%{opacity:0}to{opacity:1}}@keyframes _ngcontent-%COMP%_rotate{0%{--percent: 0deg}to{--percent: 360deg}}"]
    });
  }
  return CfCircularTimerProgressComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCircularTimerProgressModule = /*#__PURE__*/(() => {
  class CfCircularTimerProgressModule {
    static ɵfac = function CfCircularTimerProgressModule_Factory(t) {
      return new (t || CfCircularTimerProgressModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfCircularTimerProgressModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfCircularTimerProgressModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCircularProgressBarComponent = /*#__PURE__*/(() => {
  class CfCircularProgressBarComponent {
    progress = 70;
    showAnimation = true;
    theme = 'dark';
    id = 'cf-circular-progress-bar-' + Math.random().toString(36).substring(7);
    animationDuration = 10;
    animationDelay = 0;
    animationStep = 1;
    setIntervalId;
    startProgress = 0;
    endProgress = this.progress;
    document = getDocument();
    ngOnInit() {
      this.start(this.progress, this.showAnimation);
    }
    ngOnChanges(changes) {
      if (changes['showAnimation']) {
        const currentValue = changes['showAnimation'].currentValue;
        if (currentValue) setTimeout(() => this.startAnimation(), 200);
      }
      if (changes['progress']) {
        const currentValue = changes['progress'].currentValue;
        if (currentValue) this.start(currentValue, this.showAnimation);
      }
    }
    start(progress, showAnimation) {
      if (showAnimation) setTimeout(() => this.startAnimation(), 200);else setTimeout(() => this.setProgress(progress), 100);
    }
    startAnimation() {
      this.startProgress = 0;
      this.setIntervalId = setInterval(() => {
        // console.log('startProgress', this.startProgress, 'endProgress', this.endProgress);
        if (this.startProgress >= this.endProgress) return clearInterval(this.setIntervalId);
        this.setProgress(this.startProgress);
        if (this.startProgress + this.animationStep >= this.endProgress) this.startProgress = this.endProgress;else this.startProgress += this.animationStep;
      }, this.animationDuration);
    }
    setProgress(progress) {
      const outside_cicle = this.document.getElementById(this.id);
      if (outside_cicle) {
        const progressAngle = `${progress * 360 / 100}deg`;
        console.log('progressAngle', progressAngle);
        outside_cicle.style.setProperty('--progress', progressAngle);
      }
    }
    ngOnDestroy() {
      clearInterval(this.setIntervalId);
    }
    static ɵfac = function CfCircularProgressBarComponent_Factory(t) {
      return new (t || CfCircularProgressBarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfCircularProgressBarComponent,
      selectors: [["cf-circular-progress-bar"]],
      inputs: {
        progress: "progress",
        showAnimation: "showAnimation",
        theme: "theme"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 3,
      consts: [[1, "outside-circle", 3, "id", "ngClass"], [1, "inside-circle", 3, "ngClass"]],
      template: function CfCircularProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("id", ctx.id)("ngClass", ctx.theme);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.theme);
        }
      },
      dependencies: [i1$1.NgClass],
      styles: ["@property --progress{syntax: \"<angle>\"; inherits: false; initial-value: 0deg;}.outside-circle[_ngcontent-%COMP%]{height:25px;width:25px;border-radius:50%;align-items:center;display:grid}.outside-circle.dark[_ngcontent-%COMP%]{background-image:conic-gradient(#cf0 0deg var(--progress),black var(--progress))}.outside-circle.light[_ngcontent-%COMP%]{background-image:conic-gradient(#cf0 0deg var(--progress),white var(--progress))}.inside-circle[_ngcontent-%COMP%]{width:80%;height:80%;border-radius:50%;margin:auto}.inside-circle.dark[_ngcontent-%COMP%]{background:#17181C}.inside-circle.light[_ngcontent-%COMP%]{background:white}"]
    });
  }
  return CfCircularProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCircularProgressBarModule = /*#__PURE__*/(() => {
  class CfCircularProgressBarModule {
    static ɵfac = function CfCircularProgressBarModule_Factory(t) {
      return new (t || CfCircularProgressBarModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfCircularProgressBarModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfCircularProgressBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Dropdown {
  label = '';
  value = '';
  optionEnabled = true;
}
let CfDropdownComponent = /*#__PURE__*/(() => {
  class CfDropdownComponent {
    options = [];
    change = new EventEmitter();
    label = '';
    name;
    showLogo = true;
    showLabel = true;
    selected = '';
    disabled = false;
    multiple = false;
    showDescription = false;
    currentSelected = new Dropdown();
    currentMultiSelected = [];
    multiSelectText = '';
    formGroup;
    control;
    theme = 'dark';
    // HTML helpers
    objectFn = Object;
    constructor() {
      if (!this.control && !this.formGroup) {
        this.formGroup = new FormGroup({});
        this.control = new FormControl('');
      }
    }
    ngOnInit() {
      if (this.multiple) this.control.setValue([]);
      if (this.options && this.options.length > 0) {
        if (this.multiple) this.setDefaultMultipleSelection();else this.setDefaultSingleSelection();
      }
    }
    ngOnChanges(changes) {
      if (changes.selected?.currentValue) {
        this.selected = changes.selected.currentValue;
        if (this.options.length > 0) this.setDefaultSingleSelection();
      }
      if (changes.options?.currentValue.length > 0) this.setDefaultSingleSelection();
    }
    setDefaultSingleSelection() {
      if (typeof this.selected === 'string') {
        const index = this.validOption(this.selected);
        if (index === -1) {
          if (this.control.value && this.getCurrentSelectedOption(this.control.value)) this.currentSelected = this.getCurrentSelectedOption(this.control.value);else this.currentSelected = this.options[0];
        } else this.currentSelected = this.options[index];
      } else this.currentSelected = this.options[0];
      this.control.setValue(this.currentSelected.value);
    }
    setDefaultMultipleSelection() {
      if (typeof this.selected === 'string') {
        const index = this.validOption(this.selected);
        if (index === -1) this.currentMultiSelected = [this.options[0]];else this.currentMultiSelected = [this.options[index]];
        this.multiSelectText = this.currentMultiSelected.map(x => x.label).join(', ');
        this.control.setValue(this.currentMultiSelected.map(x => x.value));
      } else if (this.selected.constructor.name == 'Array') {
        const validOptions = [];
        const arr = Array.from(this.selected);
        arr.forEach(x => {
          const index = this.validOption(x);
          if (index !== -1) validOptions.push(this.options[index].value);
        });
        this.currentMultiSelected = this.getCurrentMultiSelectedOption(validOptions);
        this.multiSelectText = this.currentMultiSelected.map(x => x.label).join(', ');
        this.control.setValue(this.currentMultiSelected.map(x => x.value));
      }
    }
    validOption(value) {
      if (value === '') return -1;
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value) return i;
      }
      return -1;
    }
    changeDropdown(matSelectChange) {
      const currentSelected = this.getCurrentSelectedOption(matSelectChange.value);
      if (currentSelected) {
        this.currentSelected = currentSelected;
        this.change.emit(this.currentSelected);
      }
    }
    getCurrentSelectedOption(value) {
      return this.options.find(x => x.value === value);
    }
    getCurrentMultiSelectedOption(optionsArray) {
      let data;
      return optionsArray.map(x => {
        this.options.forEach(y => {
          if (x === y.value) data = y;
        });
        return data;
      });
    }
    changeMultiDropdown(matSelectChange) {
      this.currentMultiSelected = this.getCurrentMultiSelectedOption(matSelectChange.value);
      this.multiSelectText = this.currentMultiSelected.map(x => x.label).join(', ');
      this.change.emit(this.currentMultiSelected);
    }
    get classes() {
      return ['cf-dropdown-overlay-pane', this.theme];
    }
    static ɵfac = function CfDropdownComponent_Factory(t) {
      return new (t || CfDropdownComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfDropdownComponent,
      selectors: [["cf-dropdown"]],
      inputs: {
        options: "options",
        label: "label",
        name: "name",
        showLogo: "showLogo",
        showLabel: "showLabel",
        selected: "selected",
        disabled: "disabled",
        multiple: "multiple",
        showDescription: "showDescription",
        formGroup: "formGroup",
        control: "control",
        theme: "theme"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 8,
      vars: 9,
      consts: [[1, "cf-dropdown", "container", 3, "ngClass"], [1, "row"], [1, "col-md-12"], [4, "ngIf"], [1, "dropdown-holder", 3, "ngClass", "formGroup"], ["matNativeControl", "", "multiple", "", 3, "formControl", "ngClass", "disabled", "selectionChange", 4, "ngIf"], ["matNativeControl", "", 3, "formControl", "panelClass", "disabled", "selectionChange", 4, "ngIf"], ["class", "text-danger", 4, "ngIf"], [1, "label"], ["matNativeControl", "", "multiple", "", 3, "selectionChange", "formControl", "ngClass", "disabled"], [3, "ngStyle"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["width", "25", 3, "src", "alt", 4, "ngIf"], ["width", "25", 3, "src", "alt"], ["matNativeControl", "", 3, "selectionChange", "formControl", "panelClass", "disabled"], ["width", "25", "style", "margin-right: 0.5rem", 3, "src", "alt", 4, "ngIf"], [3, "disabled", "value", "ngClass", 4, "ngFor", "ngForOf"], ["width", "25", 2, "margin-right", "0.5rem", 3, "src", "alt"], [3, "disabled", "value", "ngClass"], [1, "primary-text"], ["class", "text-description", 4, "ngIf"], [1, "text-description"], [1, "text-danger"]],
      template: function CfDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
          i0.ɵɵtemplate(3, CfDropdownComponent_div_3_Template, 3, 1, "div", 3);
          i0.ɵɵelementStart(4, "div", 4);
          i0.ɵɵtemplate(5, CfDropdownComponent_mat_select_5_Template, 5, 8, "mat-select", 5)(6, CfDropdownComponent_mat_select_6_Template, 6, 9, "mat-select", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(7, CfDropdownComponent_span_7_Template, 2, 1, "span", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.classes);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.showLabel);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("error", ctx.control.invalid && ctx.control.touched);
          i0.ɵɵproperty("ngClass", ctx.classes)("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.multiple);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.multiple);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.errors && ctx.control.touched);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgStyle, i5.NgControlStatus, i5.NgControlStatusGroup, i5.FormControlDirective, i5.FormGroupDirective, i3$1.MatSelect, i3$1.MatSelectTrigger, i4.MatOption],
      styles: [".cf-dropdown{padding:0!important;height:max-content;margin-left:auto;margin-right:auto}.cf-dropdown .label{font-weight:700;font-size:.8rem;margin-bottom:3px}.cf-dropdown .error{border:.5px solid #dc3545!important}.cf-dropdown .dropdown-holder{display:flex;justify-content:center;margin:0rem auto;border:.5px solid grey;border-radius:9px;padding:12px 1rem;background:white}.dark .mat-select-arrow{color:#cf0}mat-select-trigger,.mat-select-trigger{width:min-content}.cf-dropdown-overlay-pane .mat-pseudo-checkbox{display:none!important}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane .primary-text{font-weight:400}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane .mat-mdc-option-active{width:100%}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane .mat-mdc-option-active .mdc-list-item__primary-text .primary-text{font-weight:700}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane.light{background-color:#fff!important}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane.light .mat-mdc-option .mdc-list-item__primary-text .primary-text,.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane.light .mat-mdc-option-active .mdc-list-item__primary-text .primary-text{color:#000}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane.dark{background-color:#1d1e22!important}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane.dark .mat-mdc-option .mdc-list-item__primary-text .primary-text{color:#d3d3d3}.cf-overlay-input-dropdown-parent-pane .cf-dropdown-overlay-pane.dark .mat-mdc-option-active .mdc-list-item__primary-text .primary-text{color:#fff}.cf-dropdown-overlay-pane.light .mat-mdc-select-arrow,.cf-dropdown-overlay-pane.dark .mat-mdc-select-arrow{color:gray}.cf-dropdown-overlay-pane .text-description{color:gray;font-weight:400;font-size:.9rem}@media only screen and (max-width: 500px){.cf-dropdown{margin-bottom:1rem;font-size:1rem}.label{font-size:1rem!important}}.cf-dropdown.dark .label{color:#fff}.cf-dropdown.dark .dropdown-holder{background:#24252B}::ng-deep .cf-dropdown-overlay-pane .mdc-list-item{width:max-content}::ng-deep .cf-dropdown-overlay-pane .mat-mdc-option-pseudo-checkbox{display:none}\n"],
      encapsulation: 2
    });
  }
  return CfDropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfDropdownModule = /*#__PURE__*/(() => {
  class CfDropdownModule {
    static ɵfac = function CfDropdownModule_Factory(t) {
      return new (t || CfDropdownModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfDropdownModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfDropdownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfInputCurrencyDropdownComponent = /*#__PURE__*/(() => {
  class CfInputCurrencyDropdownComponent {
    // for dropdown
    options = [];
    currencyChanged = new EventEmitter();
    label = '';
    name;
    id = null;
    showLabel = true;
    dark = false;
    selected = '';
    disabled = false;
    // for input
    value = 0;
    type = 'number';
    readonly = false;
    placeholder = '';
    precision = 8;
    precisionType = 'decimal';
    valueChanged = new EventEmitter();
    currentSelected = new Dropdown();
    formGroup;
    inputControl;
    currencyControl;
    theme = 'dark';
    // HTML helpers
    objectFn = Object;
    constructor() {
      if (!this.inputControl && !this.formGroup && !this.currencyControl) {
        this.formGroup = new FormGroup({});
        this.inputControl = new FormControl('');
        this.currencyControl = new FormControl('');
      }
    }
    ngOnInit() {}
    ngOnChanges(changes) {
      if (changes.value) {
        const currentValue = changes.value.currentValue.toString();
        if (this.type === 'number' && currentValue.includes('.')) {
          const str = currentValue.split('.');
          this.value = str[0] + '.' + str[1].slice(0, this.precision);
        }
        this.inputControl.setValue(this.value);
      }
      if (changes.selected && changes.selected.currentValue) {
        this.setDefaultSingleSelection();
      }
      if (changes.options && changes.options.currentValue) {
        this.setDefaultSingleSelection();
      }
    }
    setDefaultSingleSelection() {
      if (!this.options || this.options.length === 0) return;
      if (typeof this.selected === 'string') {
        const index = this.validOption(this.selected);
        if (index === -1) {
          if (this.currencyControl.value && this.getCurrentSelectedOption(this.currencyControl.value)) this.currentSelected = this.getCurrentSelectedOption(this.currencyControl.value);else this.currentSelected = this.options[0];
        } else this.currentSelected = this.options[index];
      } else this.currentSelected = this.options[0];
      this.currencyControl.setValue(this.currentSelected.value);
    }
    validOption(value) {
      if (value === '') return -1;
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value) return i;
      }
      return -1;
    }
    changeDropdown(matSelectChange) {
      const currentSelected = this.getCurrentSelectedOption(matSelectChange.value);
      if (currentSelected) {
        this.currentSelected = currentSelected;
        this.currencyChanged.emit(this.currentSelected);
      }
    }
    getCurrentSelectedOption(value) {
      return this.options.find(x => x.value === value);
    }
    valueChangedHandler($event) {
      this.valueChanged.emit($event.target.value);
    }
    static ɵfac = function CfInputCurrencyDropdownComponent_Factory(t) {
      return new (t || CfInputCurrencyDropdownComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfInputCurrencyDropdownComponent,
      selectors: [["cf-input-currency-dropdown"]],
      inputs: {
        options: "options",
        label: "label",
        name: "name",
        id: "id",
        showLabel: "showLabel",
        dark: "dark",
        selected: "selected",
        disabled: "disabled",
        value: "value",
        type: "type",
        readonly: "readonly",
        placeholder: "placeholder",
        precision: "precision",
        precisionType: "precisionType",
        formGroup: "formGroup",
        inputControl: "inputControl",
        currencyControl: "currencyControl",
        theme: "theme"
      },
      outputs: {
        currencyChanged: "currencyChanged",
        valueChanged: "valueChanged"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 17,
      vars: 32,
      consts: [[1, "cf-input-currency-dropdown", "container", 3, "ngClass"], [1, "row"], [1, "col-md-12"], [4, "ngIf"], [1, "holder", 3, "formGroup"], [1, "input-holder"], ["PrecisionDirective", "", 1, "value-span", 3, "keyup", "type", "readonly", "formControl", "placeholder", "value", "id", "precision", "precisionType"], [1, "dropdown-holder", 3, "ngClass"], ["matNativeControl", "", 3, "selectionChange", "formControl", "panelClass", "ngClass", "disabled"], [2, "display", "flex", "align-items", "center"], ["width", "25", 2, "margin-right", "0.5rem", 3, "src", "alt"], [1, "selected-option-text"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "text-danger", 4, "ngIf"], [1, "label"], [3, "value"], ["width", "25", 3, "src", "alt"], [1, "text-danger"]],
      template: function CfInputCurrencyDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
          i0.ɵɵtemplate(3, CfInputCurrencyDropdownComponent_div_3_Template, 3, 1, "div", 3);
          i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "input", 6);
          i0.ɵɵlistener("keyup", function CfInputCurrencyDropdownComponent_Template_input_keyup_6_listener($event) {
            return ctx.valueChangedHandler($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "div", 7)(8, "mat-select", 8);
          i0.ɵɵlistener("selectionChange", function CfInputCurrencyDropdownComponent_Template_mat_select_selectionChange_8_listener($event) {
            return ctx.changeDropdown($event);
          });
          i0.ɵɵelementStart(9, "mat-select-trigger", 9);
          i0.ɵɵelement(10, "img", 10);
          i0.ɵɵelementStart(11, "span", 11);
          i0.ɵɵtext(12);
          i0.ɵɵpipe(13, "uppercase");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(14, CfInputCurrencyDropdownComponent_mat_option_14_Template, 3, 4, "mat-option", 12);
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵtemplate(15, CfInputCurrencyDropdownComponent_div_15_Template, 2, 1, "div", 13)(16, CfInputCurrencyDropdownComponent_div_16_Template, 2, 1, "div", 13);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.showLabel);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("error", ctx.inputControl.invalid && ctx.inputControl.touched || ctx.currencyControl.invalid && ctx.currencyControl.touched);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("type", ctx.type)("readonly", ctx.readonly)("formControl", ctx.inputControl)("placeholder", ctx.placeholder)("value", ctx.value)("id", ctx.id)("precision", ctx.precision)("precisionType", ctx.precisionType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c7, ctx.dark));
          i0.ɵɵadvance();
          i0.ɵɵproperty("formControl", ctx.currencyControl)("panelClass", i0.ɵɵpureFunction1(28, _c8, ctx.theme))("ngClass", i0.ɵɵpureFunction1(30, _c7, ctx.dark))("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("src", ctx.currentSelected.logo, i0.ɵɵsanitizeUrl)("alt", ctx.currentSelected.label);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 24, ctx.currentSelected.value));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.options);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.inputControl.errors && ctx.inputControl.touched);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.currencyControl.errors && ctx.currencyControl.touched && !ctx.inputControl.errors);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, PrecisionDirective, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.FormControlDirective, i5.FormGroupDirective, i3$1.MatSelect, i3$1.MatSelectTrigger, i4.MatOption, i1$1.UpperCasePipe],
      styles: [".cf-input-currency-dropdown[_ngcontent-%COMP%]{padding:0;height:max-content;margin-left:auto;margin-right:auto}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;font-size:.8rem;margin-bottom:3px}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{border:.5px solid #dc3545!important}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]   .dropdown-holder[_ngcontent-%COMP%]{border-left:1px solid #dc3545!important}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]{border:.5px solid grey;border-radius:9px;padding:11.25px .5rem 11.25px 1rem;display:flex;justify-content:space-between}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{display:flex;justify-content:space-between;width:100%}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:none;width:100%;display:block;overflow-x:auto}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:none;width:100%;font-size:1rem}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .dropdown-holder[_ngcontent-%COMP%]{display:flex;justify-content:center;border-left:1px solid grey;padding-left:.5rem;min-width:100px}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .dropdown-holder.dark[_ngcontent-%COMP%]{border:none}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .dropdown-holder[_ngcontent-%COMP%]   .selected-option-text[_ngcontent-%COMP%]{color:gray;font-size:.9rem}.dark[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#cf0}mat-select-trigger[_ngcontent-%COMP%], .mat-select-trigger[_ngcontent-%COMP%]{width:max-content}@media only screen and (max-width: 500px){.cf-input-currency-dropdown[_ngcontent-%COMP%]{font-size:1rem}.label[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{font-size:1rem!important}  .cf-input-currency-dropdown .mat-select-arrow{border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid}}button[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:focus{outline:none}input[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:active, input[_ngcontent-%COMP%]:-webkit-autofill:focus, input[_ngcontent-%COMP%]:-webkit-autofill:hover{-webkit-box-shadow:0 0 0 30px white inset!important}input[_ngcontent-%COMP%]::-webkit-inner-spin-button, input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{appearance:textfield}.cf-input-currency-dropdown.dark[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#fff}.cf-input-currency-dropdown.dark[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]{background:#24252B}.cf-input-currency-dropdown.dark[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background:#24252B;color:#fff}  .cf-overlay-input-dropdown-parent-pane{min-width:max-content!important}  .cf-overlay-input-dropdown-child-pane .mdc-list-item{width:max-content}  .cf-overlay-input-dropdown-child-pane .mat-mdc-option-pseudo-checkbox{display:none}  .cf-overlay-input-dropdown-child-pane.dark .mdc-list-item__primary-text{color:#000!important;width:max-content}  .cf-overlay-input-dropdown-child-pane .mat-mdc-select{display:grid!important}  .cf-input-currency-dropdown .dark .mat-mdc-select-arrow{color:#fff}.cf-input-currency-dropdown.light[_ngcontent-%COMP%]   .mat-mdc-select-arrow[_ngcontent-%COMP%], .cf-input-currency-dropdown.dark[_ngcontent-%COMP%]   .mat-mdc-select-arrow[_ngcontent-%COMP%]{color:gray}.cf-input-currency-dropdown[_ngcontent-%COMP%]   .mat-mdc-select[_ngcontent-%COMP%]{display:grid!important}  .mat-mdc-option-active{width:100%}  .cf-overlay-input-dropdown-child-pane.light .mdc-list-item__primary-text{width:100%;display:flex;gap:.5rem;align-items:center;color:#000!important}  .cf-overlay-input-dropdown-child-pane .mat-mdc-option-active{width:100%}  .cf-overlay-input-dropdown-child-pane .mat-mdc-option-active .mdc-list-item__primary-text{font-weight:700!important;display:flex;gap:.5rem;align-items:center;color:#000!important}  .cf-overlay-input-dropdown-child-pane.dark{background-color:#1d1e22}  .cf-overlay-input-dropdown-child-pane.light{background-color:#fff}"]
    });
  }
  return CfInputCurrencyDropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfInputCurrencyDropdownModule = /*#__PURE__*/(() => {
  class CfInputCurrencyDropdownModule {
    static ɵfac = function CfInputCurrencyDropdownModule_Factory(t) {
      return new (t || CfInputCurrencyDropdownModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfInputCurrencyDropdownModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: MAT_SELECT_CONFIG,
        useValue: {
          overlayPanelClass: 'cf-overlay-input-dropdown-parent-pane'
        }
      }],
      imports: [CommonModule, SharedModule]
    });
  }
  return CfInputCurrencyDropdownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfInputComponent = /*#__PURE__*/(() => {
  class CfInputComponent {
    clipboardService;
    cfAlertService;
    label;
    showLabel = true;
    type = 'text';
    class;
    id;
    name;
    placeholder = '';
    showPlaceholder = false;
    value;
    readonly = false;
    copy = false;
    showRequiredSign = false;
    trim = false;
    trimLength = 22;
    precision = 8;
    precisionType = 'decimal';
    maxLength = null;
    minLength = null;
    tooltip = '';
    valueChanged = new EventEmitter();
    showPassword = false;
    trimmedValue = '';
    formGroup;
    control;
    theme = 'dark';
    // HTML helpers
    objectFn = Object;
    constructor(clipboardService, cfAlertService) {
      this.clipboardService = clipboardService;
      this.cfAlertService = cfAlertService;
      if (!this.control && !this.formGroup) {
        this.formGroup = new FormGroup({});
        this.control = new FormControl('');
      }
    }
    ngOnChanges(changes) {
      // console.log('ngOnChanges', changes);
      if (changes.value) {
        const currentValue = changes.value.currentValue;
        // console.log('currentValue', currentValue);
        if (this.trim && currentValue.length > this.trimLength) this.trimmedValue = currentValue.slice(0, this.trimLength) + '...';else this.trimmedValue = currentValue;
        this.control.setValue(currentValue);
      }
    }
    onPaste(event) {
      const clipboardData = event.clipboardData;
      const pastedText = clipboardData?.getData('text');
      if (!pastedText) return;
      // console.log('onPaste', pastedText);
      // console.log('this.type', this.type);
      if (this.type === 'number') {
        if (Number(pastedText)) this.valueChanged.emit(pastedText);else {
          this.trimmedValue = '';
          this.value = '';
        }
      } else {
        this.valueChanged.emit(pastedText);
      }
      event.preventDefault();
      event.stopPropagation();
    }
    ngOnInit() {
      // console.log(this.formGroup);
    }
    keyUpHandler($event) {
      // console.log('keyUpHandler', this.label, $event.target.value);
      if (this.trim && $event.target.value.length > this.trimLength) this.trimmedValue = $event.target.value.slice(0, this.trimLength) + '...';else this.trimmedValue = $event.target.value;
      this.valueChanged.emit($event.target.value);
    }
    copyContent() {
      this.clipboardService.copy(this.control.value);
      this.cfAlertService.showSuccess(this.label + ' copied!');
    }
    get classes() {
      return this.theme === 'dark' ? 'dark' : '';
    }
    static ɵfac = function CfInputComponent_Factory(t) {
      return new (t || CfInputComponent)(i0.ɵɵdirectiveInject(i1$3.Clipboard), i0.ɵɵdirectiveInject(CfAlertService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfInputComponent,
      selectors: [["cf-input"]],
      inputs: {
        label: "label",
        showLabel: "showLabel",
        type: "type",
        class: "class",
        id: "id",
        name: "name",
        placeholder: "placeholder",
        showPlaceholder: "showPlaceholder",
        value: "value",
        readonly: "readonly",
        copy: "copy",
        showRequiredSign: "showRequiredSign",
        trim: "trim",
        trimLength: "trimLength",
        precision: "precision",
        precisionType: "precisionType",
        maxLength: "maxLength",
        minLength: "minLength",
        tooltip: "tooltip",
        formGroup: "formGroup",
        control: "control",
        theme: "theme"
      },
      outputs: {
        valueChanged: "valueChanged"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 14,
      consts: [[3, "ngClass"], [4, "ngIf"], [1, "input-holder", 3, "formGroup"], [3, "class", 4, "ngIf"], ["class", "value-span", "PrecisionDirective", "", 3, "type", "name", "id", "placeholder", "value", "formControl", "maxlength", "minLength", "precision", "precisionType", "keyup", "paste", 4, "ngIf"], ["class", "value-span", 3, "type", "name", "id", "placeholder", "value", "formControl", "maxlength", "minLength", "keyup", 4, "ngIf"], ["class", "fa-solid fa-copy", 3, "matTooltip", "click", 4, "ngIf"], ["style", "cursor: pointer", 3, "click", 4, "ngIf"], ["class", "text-danger", 4, "ngIf"], ["class", "fa-solid fa-circle-info ms-1", 3, "matTooltip", 4, "ngIf"], ["style", "color: red", 4, "ngIf"], [1, "fa-solid", "fa-circle-info", "ms-1", 3, "matTooltip"], [2, "color", "red"], ["style", "color: gray", 4, "ngIf"], [2, "color", "gray"], ["PrecisionDirective", "", 1, "value-span", 3, "keyup", "paste", "type", "name", "id", "placeholder", "value", "formControl", "maxlength", "minLength", "precision", "precisionType"], [1, "value-span", 3, "keyup", "type", "name", "id", "placeholder", "value", "formControl", "maxlength", "minLength"], [1, "fa-solid", "fa-copy", 3, "click", "matTooltip"], [2, "cursor", "pointer", 3, "click"], ["class", "fa-solid fa-eye", 4, "ngIf"], ["class", "fa-solid fa-eye-slash", 4, "ngIf"], [1, "fa-solid", "fa-eye"], [1, "fa-solid", "fa-eye-slash"], [1, "text-danger"]],
      template: function CfInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CfInputComponent_div_1_Template, 5, 4, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, CfInputComponent_span_3_Template, 3, 4, "span", 3)(4, CfInputComponent_input_4_Template, 1, 10, "input", 4)(5, CfInputComponent_input_5_Template, 1, 8, "input", 5)(6, CfInputComponent_i_6_Template, 1, 1, "i", 6)(7, CfInputComponent_span_7_Template, 3, 2, "span", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, CfInputComponent_span_8_Template, 2, 1, "span", 8);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c9, ctx.control.errors && ctx.control.invalid && ctx.control.touched ? "cf-input mb-0" : "cf-input", ctx.theme));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showLabel);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("error", ctx.control.invalid && ctx.control.touched);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.readonly && ctx.type !== "password");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.readonly && ctx.type === "password");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.copy);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "password");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.errors && ctx.control.touched);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, PrecisionDirective, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.MaxLengthValidator, i5.FormControlDirective, i5.FormGroupDirective, i6.MatTooltip],
      styles: [".cf-input[_ngcontent-%COMP%]{padding:0;height:max-content;margin-left:auto;margin-right:auto;margin-bottom:0rem}.cf-input[_ngcontent-%COMP%]   .fa-circle-info[_ngcontent-%COMP%]{color:gray;font-size:.8rem}.cf-input[_ngcontent-%COMP%]   .fa-circle-info[_ngcontent-%COMP%]:hover{cursor:pointer;color:#000}.cf-input[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{border:.5px solid #dc3545!important}.cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{border-radius:9px;padding:1rem;display:grid;grid-template-columns:1fr auto;column-gap:15px}.cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:none;width:100%;display:block;overflow-x:auto}.cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:none;width:100%;font-size:1rem}.cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{margin-left:1rem;cursor:pointer;align-self:center}.cf-input[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%], .cf-input[_ngcontent-%COMP%]   .white-label[_ngcontent-%COMP%]{font-weight:700;font-size:.8rem;text-align:left;display:flex;margin-bottom:3px}.cf-input[_ngcontent-%COMP%]   .white-label[_ngcontent-%COMP%]{color:#fff}@media only screen and (max-width: 500px){.input[_ngcontent-%COMP%], .label[_ngcontent-%COMP%], .cf-input[_ngcontent-%COMP%]   .white-label[_ngcontent-%COMP%]{font-size:1rem!important}.cf-input[_ngcontent-%COMP%]{margin-bottom:1.5rem!important}.cf-input[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%], .cf-input[_ngcontent-%COMP%]   .white-label[_ngcontent-%COMP%], .cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%], .cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .span[_ngcontent-%COMP%], .cf-input[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{font-size:1rem!important}}button[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:focus{outline:none}input[_ngcontent-%COMP%]:disabled{background:transparent!important}input[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:active, input[_ngcontent-%COMP%]:-webkit-autofill:focus, input[_ngcontent-%COMP%]:-webkit-autofill:hover{-webkit-box-shadow:0 0 0 30px white inset!important}input[_ngcontent-%COMP%]::-webkit-inner-spin-button, input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{appearance:textfield}.cf-input.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{background:#24252b;border:.5px solid grey}.cf-input.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background:#24252b;color:#fff}.cf-input.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{color:gray}.cf-input.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]:hover{color:#d3d3d3}.cf-input.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{background:white;border:.1px solid #f5f5f5}.cf-input.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background:white;color:#000}.cf-input.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{color:gray}.cf-input.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]:hover{color:#000}input[_ngcontent-%COMP%], input[_ngcontent-%COMP%]:before, input[_ngcontent-%COMP%]:after{-webkit-user-select:initial;user-select:initial}"]
    });
  }
  return CfInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfInputModule = /*#__PURE__*/(() => {
  class CfInputModule {
    static ɵfac = function CfInputModule_Factory(t) {
      return new (t || CfInputModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfInputModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfInputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfInputCurrencyComponent = /*#__PURE__*/(() => {
  class CfInputCurrencyComponent {
    clipboardService;
    cfAlertService;
    label = '';
    name;
    id;
    value = 0;
    precision = 8;
    precisionType = 'decimal';
    currency = '';
    currencyLogo = '';
    readonly = false;
    placeholder = '';
    labelRight = '';
    copy = false;
    theme = 'dark';
    maxLength = null;
    minLength = null;
    valueChanged = new EventEmitter();
    formGroup;
    control;
    // HTML helpers
    objectFn = Object;
    constructor(clipboardService, cfAlertService) {
      this.clipboardService = clipboardService;
      this.cfAlertService = cfAlertService;
      if (!this.control && !this.formGroup) {
        this.formGroup = new FormGroup({});
        this.control = new FormControl('');
        this.control.setValue(this.value);
      }
    }
    ngOnChanges(changes) {
      if (changes?.value) {
        const currentValue = changes.value.currentValue.toString();
        console.log('ngOnChanges currentValue', currentValue);
        if (currentValue.includes('.')) {
          const str = currentValue.split('.');
          console.log('ngOnChanges str', str);
          this.value = str[0] + '.' + str[1].slice(0, this.precision);
          console.log('ngOnChanges value', this.value);
        }
        this.control.setValue(this.value);
      }
    }
    keyUpHandler($event) {
      console.log('keyUpHandler', $event, $event.target.value);
      this.valueChanged.emit($event.target.value);
    }
    keyDownHandler($event) {
      console.log('keyDownHandler', $event, $event.target.value);
    }
    inputHandler($event) {
      console.log('inputHandler', $event, $event.target.value);
    }
    copyContent() {
      this.clipboardService.copy(this.value.toString());
      this.cfAlertService.showSuccess(this.label + ' copied!');
    }
    static ɵfac = function CfInputCurrencyComponent_Factory(t) {
      return new (t || CfInputCurrencyComponent)(i0.ɵɵdirectiveInject(i1$3.Clipboard), i0.ɵɵdirectiveInject(CfAlertService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfInputCurrencyComponent,
      selectors: [["cf-input-currency"]],
      inputs: {
        label: "label",
        name: "name",
        id: "id",
        value: "value",
        precision: "precision",
        precisionType: "precisionType",
        currency: "currency",
        currencyLogo: "currencyLogo",
        readonly: "readonly",
        placeholder: "placeholder",
        labelRight: "labelRight",
        copy: "copy",
        theme: "theme",
        maxLength: "maxLength",
        minLength: "minLength",
        formGroup: "formGroup",
        control: "control"
      },
      outputs: {
        valueChanged: "valueChanged"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 16,
      vars: 23,
      consts: [[1, "cf-input-currency", 3, "ngClass"], [1, "label-wrapper"], [1, "label"], [1, "input-holder", 3, "formGroup"], [1, "d-flex", "align-items-center", "w-100"], ["type", "number", "PrecisionDirective", "", "step", "any", 1, "value-span", 3, "keyup", "keydown", "input", "name", "id", "placeholder", "value", "formControl", "maxlength", "minLength", "readonly", "precisionType", "precision"], ["class", "fa-solid fa-copy", 3, "matTooltip", "click", 4, "ngIf"], [1, "currency-span"], [3, "src", "alt"], [1, "currency-text"], ["class", "text-danger", 4, "ngIf"], [1, "fa-solid", "fa-copy", 3, "click", "matTooltip"], [1, "text-danger"]],
      template: function CfInputCurrencyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "label", 2);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 3)(7, "div", 4)(8, "input", 5);
          i0.ɵɵlistener("keyup", function CfInputCurrencyComponent_Template_input_keyup_8_listener($event) {
            return ctx.keyUpHandler($event);
          })("keydown", function CfInputCurrencyComponent_Template_input_keydown_8_listener($event) {
            return ctx.keyDownHandler($event);
          })("input", function CfInputCurrencyComponent_Template_input_input_8_listener($event) {
            return ctx.inputHandler($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, CfInputCurrencyComponent_i_9_Template, 1, 1, "i", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "span", 7);
          i0.ɵɵelement(11, "img", 8);
          i0.ɵɵelementStart(12, "span", 9);
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "uppercase");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(15, CfInputCurrencyComponent_span_15_Template, 2, 1, "span", 10);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.label);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.labelRight);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("error", ctx.control.invalid && ctx.control.touched);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("name", ctx.name)("id", ctx.id)("placeholder", ctx.placeholder)("value", ctx.value)("formControl", ctx.control)("maxlength", ctx.maxLength)("minLength", ctx.minLength)("readonly", ctx.readonly)("precisionType", ctx.precisionType)("precision", ctx.precision);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.copy);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("src", ctx.currencyLogo, i0.ɵɵsanitizeUrl)("alt", ctx.label);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 21, ctx.currency));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.control.errors && ctx.control.touched);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, PrecisionDirective, i5.DefaultValueAccessor, i5.NumberValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.MaxLengthValidator, i5.FormControlDirective, i5.FormGroupDirective, i6.MatTooltip, i1$1.UpperCasePipe],
      styles: [".cf-input-currency[_ngcontent-%COMP%]{padding:0;height:max-content;margin-left:auto;margin-right:auto}.cf-input-currency[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{border:.5px solid #dc3545!important}.cf-input-currency[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]   .currency-span[_ngcontent-%COMP%]{border-left:1px solid #dc3545!important}.cf-input-currency[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{border-radius:9px;padding:9.25px 1rem;display:flex;justify-content:space-between}.cf-input-currency[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .value-span[_ngcontent-%COMP%]{border:none;width:100%;line-height:2rem;font-size:1rem;background-color:transparent}.cf-input-currency[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .currency-span[_ngcontent-%COMP%]{padding-left:.5rem;display:flex;align-items:center}.cf-input-currency[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .currency-span[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:25px;height:25px;margin-right:5px}.cf-input-currency[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{margin-right:.5rem;margin-left:.5rem;cursor:pointer;align-self:center}.cf-input-currency[_ngcontent-%COMP%]   .label-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.cf-input-currency[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;font-size:.8rem;margin-bottom:3px}button[_ngcontent-%COMP%]:focus, input[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:focus{outline:none}input[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:active, input[_ngcontent-%COMP%]:-webkit-autofill:focus, input[_ngcontent-%COMP%]:-webkit-autofill:hover{-webkit-box-shadow:0 0 0 30px white inset!important}input[_ngcontent-%COMP%]::-webkit-inner-spin-button, input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{appearance:textfield}@media only screen and (max-width: 500px){.label[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{font-size:1rem!important}.currency-span[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:32px;height:32px}}[_ngcontent-%COMP%]:root.dark{--mat-option-selected-state-label-text-color: white;--mat-option-selected-state-layer-color: lightgrey;--mat-select-panel-background-color: #1D1E22;--mat-select-enabled-arrow-color: grey}[_ngcontent-%COMP%]:root.light{--mat-option-selected-state-label-text-color: black;--mat-option-selected-state-layer-color: lightgrey;--mat-select-panel-background-color: white;--mat-select-enabled-arrow-color: grey}.cf-input-currency.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{border:.5px solid grey;background-color:#24252a}.cf-input-currency.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .value-span[_ngcontent-%COMP%]{color:#fff}.cf-input-currency.dark[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .currency-span[_ngcontent-%COMP%]{border-left:1px solid grey;color:gray}.cf-input-currency.dark[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#fff}.cf-input-currency.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{border:.5px solid #f5f5f5}.cf-input-currency.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .value-span[_ngcontent-%COMP%]{color:#000}.cf-input-currency.light[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .currency-span[_ngcontent-%COMP%]{border-left:1px solid #f5f5f5;color:gray}.cf-input-currency.light[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#000}"]
    });
  }
  return CfInputCurrencyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfInputCurrencyModule = /*#__PURE__*/(() => {
  class CfInputCurrencyModule {
    static ɵfac = function CfInputCurrencyModule_Factory(t) {
      return new (t || CfInputCurrencyModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfInputCurrencyModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfInputCurrencyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfRedirectComponent = /*#__PURE__*/(() => {
  class CfRedirectComponent {
    clipboard;
    value;
    class;
    label;
    trim = false;
    trimLength = 22;
    trimmedValue = '';
    constructor(clipboard) {
      this.clipboard = clipboard;
      this.value = '';
      this.class = '';
      this.label = '';
    }
    ngOnChanges(changes) {
      if (changes.value) {
        const currentValue = changes.value.currentValue;
        if (this.trim && currentValue.length > this.trimLength) this.trimmedValue = currentValue.slice(0, this.trimLength) + '...';else this.trimmedValue = currentValue;
      }
    }
    copyAddress(address) {
      this.clipboard?.copy(address);
    }
    static ɵfac = function CfRedirectComponent_Factory(t) {
      return new (t || CfRedirectComponent)(i0.ɵɵdirectiveInject(i1$3.Clipboard));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfRedirectComponent,
      selectors: [["cf-redirect"]],
      inputs: {
        value: "value",
        class: "class",
        label: "label",
        trim: "trim",
        trimLength: "trimLength"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 10,
      vars: 9,
      consts: [[1, "cf-redirect"], [1, "label"], [1, "redirect-holder"], ["target", "_blank", 3, "href"], [1, "fa-solid", "fa-copy", 3, "click", "matTooltip"], ["matTooltip", "Open in new tab", 1, "fa-solid", "fa-square-up-right"]],
      template: function CfRedirectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "label", 1);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 2)(5, "a", 3);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "i", 4);
          i0.ɵɵlistener("click", function CfRedirectComponent_Template_i_click_7_listener() {
            return ctx.copyAddress(ctx.value);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "a", 3);
          i0.ɵɵelement(9, "i", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.label);
          i0.ɵɵadvance(2);
          i0.ɵɵclassMap(ctx.class);
          i0.ɵɵproperty("href", ctx.value, i0.ɵɵsanitizeUrl);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.trimmedValue, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("matTooltip", "Copy " + ctx.label);
          i0.ɵɵadvance();
          i0.ɵɵclassMap(ctx.class);
          i0.ɵɵproperty("href", ctx.value, i0.ɵɵsanitizeUrl);
        }
      },
      dependencies: [i6.MatTooltip],
      styles: [".cf-redirect[_ngcontent-%COMP%]{padding:0 1rem;height:max-content;margin-left:auto;margin-right:auto;margin-bottom:1rem}.cf-redirect[_ngcontent-%COMP%]   .redirect-holder[_ngcontent-%COMP%]{border:.5px solid rgba(0,0,0,.05);border-radius:2px;padding:.4rem 1rem;display:flex;justify-content:space-between}.cf-redirect[_ngcontent-%COMP%]   .redirect-holder[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{border:none;overflow-wrap:anywhere}.cf-redirect[_ngcontent-%COMP%]   .redirect-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{margin-left:.5em;font-size:1rem}.cf-redirect[_ngcontent-%COMP%]   .redirect-holder[_ngcontent-%COMP%]   .fa-square-up-right[_ngcontent-%COMP%]{color:#000;margin-left:.5em;font-size:1rem}.cf-redirect[_ngcontent-%COMP%]   .redirect-holder[_ngcontent-%COMP%]   .fa-square-up-right[_ngcontent-%COMP%]:hover{color:#00000080;cursor:pointer}.cf-redirect[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;font-size:.8rem}"]
    });
  }
  return CfRedirectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfRedirectModule = /*#__PURE__*/(() => {
  class CfRedirectModule {
    static ɵfac = function CfRedirectModule_Factory(t) {
      return new (t || CfRedirectModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfRedirectModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfRedirectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfToggleComponent = /*#__PURE__*/(() => {
  class CfToggleComponent {
    checked = false;
    tooltip = '';
    theme = 'dark';
    change = new EventEmitter();
    constructor() {}
    changeHandler($event) {
      this.change.emit($event.checked);
    }
    static ɵfac = function CfToggleComponent_Factory(t) {
      return new (t || CfToggleComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfToggleComponent,
      selectors: [["cf-toggle"]],
      inputs: {
        checked: "checked",
        tooltip: "tooltip",
        theme: "theme"
      },
      outputs: {
        change: "change"
      },
      decls: 2,
      vars: 2,
      consts: [[1, "cf-toggle"], [3, "change", "checked", "matTooltip"]],
      template: function CfToggleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "mat-slide-toggle", 1);
          i0.ɵɵlistener("change", function CfToggleComponent_Template_mat_slide_toggle_change_1_listener($event) {
            return ctx.changeHandler($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("checked", ctx.checked)("matTooltip", ctx.tooltip);
        }
      },
      dependencies: [i6.MatTooltip, i2.MatSlideToggle],
      styles: [".cf-toggle[_ngcontent-%COMP%]{width:min-content;margin:auto}  .cf-toggle .mdc-switch:enabled .mdc-switch__track:after{background-color:#ccff00b3}  .cf-toggle .mat-slide-toggle.mat-checked .mat-slide-toggle-bar{background-color:#cf0}  .cf-toggle .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background-color:#cf0}  .cf-toggle .mdc-switch.mdc-switch--selected:enabled .mdc-switch__icon{fill:#000}  .cf-toggle .mdc-switch:enabled .mdc-switch__track:after:hover{background-color:#cf0}  .mat-mdc-slide-toggle.mat-mdc-slide-toggle-checked:not(.mat-disabled) .mdc-switch__shadow{background-color:#cf0}  .mat-mdc-slide-toggle.mat-mdc-slide-toggle-checked:not(.mat-disabled) .mdc-switch__track:after{background-color:#ccff00b3!important}"]
    });
  }
  return CfToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfToggleModule = /*#__PURE__*/(() => {
  class CfToggleModule {
    static ɵfac = function CfToggleModule_Factory(t) {
      return new (t || CfToggleModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfToggleModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfToggleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfVerticalProgressBarComponent = /*#__PURE__*/(() => {
  class CfVerticalProgressBarComponent {
    selectedIndex = 0;
    currentState = '';
    steps = [];
    currentStep = 0;
    changeStep = new EventEmitter();
    theme = 'dark';
    constructor() {}
    ngOnInit() {}
    changeStepHandler(index) {
      this.changeStep.emit(index);
    }
    static ɵfac = function CfVerticalProgressBarComponent_Factory(t) {
      return new (t || CfVerticalProgressBarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfVerticalProgressBarComponent,
      selectors: [["cf-vertical-progress-bar"]],
      inputs: {
        steps: "steps",
        currentStep: "currentStep",
        theme: "theme"
      },
      outputs: {
        changeStep: "changeStep"
      },
      decls: 2,
      vars: 2,
      consts: [[1, "cf-vertical-progress-bar", 3, "ngClass"], ["class", "step-container", 4, "ngFor", "ngForOf"], [1, "step-container"], [1, "step-heading"], [1, "step", 3, "click", "ngClass"], [1, "step-counter"], ["style", "bottom: 5px; position: relative;", 4, "ngIf"], ["class", "fa-solid fa-check", 4, "ngIf"], [1, "step-title"], [1, "step-content"], [2, "bottom", "5px", "position", "relative"], [1, "fa-solid", "fa-check"]],
      template: function CfVerticalProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CfVerticalProgressBarComponent_div_1_Template, 10, 8, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.steps);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf],
      styles: [".cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]{padding-left:0rem;padding-right:1rem;padding-bottom:.5rem}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]{display:flex;justify-content:left;margin-top:0;gap:.5rem}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{display:flex;gap:.5rem;align-items:center}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:hover{cursor:pointer}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{border-radius:50%;background-color:#24252b;color:#d3d3d3;width:30px;height:30px;font-size:.9rem;align-items:center;text-align:center;display:grid}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#d3d3d3}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-divider[_ngcontent-%COMP%]{color:#d3d3d3;width:100px}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]:last-child   .step-divider[_ngcontent-%COMP%]{display:none!important}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-active[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{font-weight:500}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-active[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#fff;font-weight:500}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-complete[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{background-color:#cf0;color:#000;width:25px;height:25px}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-complete[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#cf0}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{padding-left:1rem;margin-left:.75rem;margin-top:1rem;min-height:1rem}.cf-vertical-progress-bar[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]:last-child   .step-content[_ngcontent-%COMP%]{border-left:none}.cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{background-color:#24252b;color:#d3d3d3}.cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%], .cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-divider[_ngcontent-%COMP%]{color:#d3d3d3}.cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-active[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#fff}.cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-complete[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{background-color:#cf0;color:#000}.cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-complete[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#cf0;font-weight:400}.cf-vertical-progress-bar.dark[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{border-left:.1px solid grey;color:#d3d3d3}.cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{background-color:#d3d3d3;color:#000}.cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%], .cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-divider[_ngcontent-%COMP%]{color:gray}.cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-active[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#000}.cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-complete[_ngcontent-%COMP%]   .step-counter[_ngcontent-%COMP%]{background-color:#cf0;color:#000}.cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-heading[_ngcontent-%COMP%]   .step-complete[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#000;font-weight:700}.cf-vertical-progress-bar.light[_ngcontent-%COMP%]   .step-container[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{color:gray;border-left:.2px solid #f5f5f5}"]
    });
  }
  return CfVerticalProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfVerticalProgressBarModule = /*#__PURE__*/(() => {
  class CfVerticalProgressBarModule {
    static ɵfac = function CfVerticalProgressBarModule_Factory(t) {
      return new (t || CfVerticalProgressBarModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfVerticalProgressBarModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfVerticalProgressBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfPaginatorComponent = /*#__PURE__*/(() => {
  class CfPaginatorComponent {
    page = 1;
    count = 0;
    limit = 10;
    theme = 'dark';
    changed = new EventEmitter();
    before = [];
    after = [];
    displayLimit = 2;
    lastPage = 0;
    constructor() {}
    ngOnInit() {
      this.generatePagination();
    }
    ngOnChanges(changes) {
      if (changes?.count?.currentValue) {
        this.count = changes?.count?.currentValue;
        this.generatePagination();
      }
      if (changes?.page?.currentValue === 1) this.generatePagination();
    }
    generatePagination() {
      let d = this.count / this.limit;
      if (this.count % this.limit > 0) d += 1;
      const arr = new Array(parseInt(d.toString()));
      this.lastPage = arr.length;
      this.generateBefore();
      this.generateAfter();
    }
    changedHandler(page) {
      // zero based index
      this.changed.emit(page - 1);
      this.page = page;
      this.generateBefore();
      this.generateAfter();
    }
    generateBefore() {
      const before = [];
      for (let i = this.displayLimit; i >= 1; i--) {
        const page = this.page - i;
        if (page > 0) before.push(page);
      }
      this.before = before;
    }
    generateAfter() {
      const after = [];
      const maxLimit = Math.ceil(this.count / this.limit);
      for (let i = 1; i <= this.displayLimit; i++) {
        const page = this.page + i;
        if (page <= maxLimit) after.push(page);
      }
      this.after = after;
    }
    static ɵfac = function CfPaginatorComponent_Factory(t) {
      return new (t || CfPaginatorComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfPaginatorComponent,
      selectors: [["cf-paginator"]],
      inputs: {
        page: "page",
        count: "count",
        limit: "limit",
        theme: "theme"
      },
      outputs: {
        changed: "changed"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 8,
      vars: 6,
      consts: [[1, "cf-paginator", 3, "ngClass"], [1, "pages"], ["class", "page", 3, "ngClass", "click", 4, "ngIf"], ["class", "page", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "current", "page"], [1, "page", 3, "click", "ngClass"]],
      template: function CfPaginatorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, CfPaginatorComponent_div_2_Template, 2, 1, "div", 2)(3, CfPaginatorComponent_div_3_Template, 2, 2, "div", 3);
          i0.ɵɵelementStart(4, "div", 4);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, CfPaginatorComponent_div_6_Template, 2, 2, "div", 3)(7, CfPaginatorComponent_div_7_Template, 2, 1, "div", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.page > 1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.before);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.page);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.after);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.page !== ctx.lastPage);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf],
      styles: [".cf-paginator[_ngcontent-%COMP%]{width:max-content;margin:1rem auto}.cf-paginator[_ngcontent-%COMP%]   .pages[_ngcontent-%COMP%]{display:flex}.cf-paginator[_ngcontent-%COMP%]   .page[_ngcontent-%COMP%]{font-size:.8rem;margin-left:.3rem;margin-right:.3rem;line-height:1rem}.cf-paginator[_ngcontent-%COMP%]   .page[_ngcontent-%COMP%]:not(.current):hover{cursor:pointer}.cf-paginator[_ngcontent-%COMP%]   .current[_ngcontent-%COMP%]{font-size:1.2rem}.cf-paginator.dark[_ngcontent-%COMP%]   .page[_ngcontent-%COMP%]{color:gray}.cf-paginator.dark[_ngcontent-%COMP%]   .current[_ngcontent-%COMP%]{color:#fff!important}.cf-paginator.light[_ngcontent-%COMP%]   .page[_ngcontent-%COMP%]{color:#000}.cf-paginator.light[_ngcontent-%COMP%]   .current[_ngcontent-%COMP%]{color:#000!important}"]
    });
  }
  return CfPaginatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfPaginatorModule = /*#__PURE__*/(() => {
  class CfPaginatorModule {
    static ɵfac = function CfPaginatorModule_Factory(t) {
      return new (t || CfPaginatorModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfPaginatorModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfPaginatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfMobileNumberComponent = /*#__PURE__*/(() => {
  class CfMobileNumberComponent {
    mobileNumber = '';
    options = [];
    selected = '';
    showLabel = true;
    readonly = false;
    label = '';
    length = 10;
    placeholder = '';
    name;
    id = null;
    disabled = false;
    dialCodeChanged = new EventEmitter();
    mobileNumberChanged = new EventEmitter();
    maxLength = null;
    minLength = null;
    currentSelected = {
      countryCode: '',
      countryName: '',
      dialCode: '',
      flagUrl: '',
      mobileNumberLength: 10
    };
    allowedKeys = new Set();
    formGroup;
    inputControl;
    dialCodeControl;
    // HTML helpers
    objectFn = Object;
    constructor() {
      if (!this.inputControl && !this.formGroup && !this.dialCodeControl) {
        this.formGroup = new FormGroup({});
        this.inputControl = new FormControl('');
        this.dialCodeControl = new FormControl('');
      }
    }
    ngOnInit() {
      const allowedKeys = ['Backspace', 'Digit0', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'];
      this.allowedKeys = new Set(allowedKeys);
    }
    validOption(value) {
      if (value === '') return -1;
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].dialCode === value) return i;
      }
      return -1;
    }
    changeDropdown(matSelectChange) {
      this.currentSelected = matSelectChange.value;
      this.dialCodeChanged.emit(this.currentSelected);
    }
    ngOnChanges(changes) {
      if (changes.mobileNumber) {
        this.mobileNumber = changes.mobileNumber.currentValue;
        this.inputControl.setValue(this.mobileNumber);
      }
      if (changes.selected && changes.selected.currentValue) this.setSelectedValue();
      if (changes.options && changes.options.currentValue) this.setSelectedValue();
    }
    setSelectedValue() {
      if (this.selected === '') return;
      if (!this.options) return;
      if (this.options.length === 0) return;
      const index = this.validOption(this.selected);
      if (index === -1) this.currentSelected = this.options[0];else this.currentSelected = this.options[index];
      this.dialCodeControl.setValue(this.currentSelected);
    }
    valueChangedHandler($event) {
      this.mobileNumberChanged.emit($event.target.value);
    }
    keydown(event) {
      const allowed = this.allowedKeys.has(event.code);
      if (!allowed) return false;
      if (!this.optionalKeys(event)) {
        // equality is needed to avoid the edge condition
        if (this.mobileNumber.length >= this.length) return false;
      }
      return true;
    }
    optionalKeys(event) {
      if (event.code === 'Backspace') return true;
      if (event.code === 'ArrowLeft') return true;
      if (event.code === 'ArrowRight') return true;
      if (event.code === 'ArrowUp') return true;
      if (event.code === 'ArrowDown') return true;
      return false;
    }
    static ɵfac = function CfMobileNumberComponent_Factory(t) {
      return new (t || CfMobileNumberComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfMobileNumberComponent,
      selectors: [["cf-mobile-number"]],
      inputs: {
        mobileNumber: "mobileNumber",
        options: "options",
        selected: "selected",
        showLabel: "showLabel",
        readonly: "readonly",
        label: "label",
        length: "length",
        placeholder: "placeholder",
        name: "name",
        id: "id",
        disabled: "disabled",
        maxLength: "maxLength",
        minLength: "minLength",
        formGroup: "formGroup",
        inputControl: "inputControl",
        dialCodeControl: "dialCodeControl"
      },
      outputs: {
        dialCodeChanged: "dialCodeChanged",
        mobileNumberChanged: "mobileNumberChanged"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 16,
      vars: 13,
      consts: [[1, "cf-mobile-number"], [1, "label"], [1, "holder", 3, "formGroup"], [1, "dropdown-holder"], ["matNativeControl", "", 3, "selectionChange", "formControl"], ["width", "30", 2, "margin-right", "0.3rem", 3, "src", "alt"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], ["class", "isd-code-holder", 4, "ngIf"], [1, "input-holder"], [4, "ngIf"], ["type", "number", "class", "value-span", 3, "name", "id", "value", "placeholder", "formControl", "minLength", "maxlength", "keyup", 4, "ngIf"], ["class", "text-danger", 4, "ngIf"], [3, "value", "disabled"], ["width", "25", 2, "margin-right", "0.5rem", 3, "src", "alt"], [2, "color", "grey"], [1, "isd-code-holder"], ["type", "number", 1, "value-span", 3, "keyup", "name", "id", "value", "placeholder", "formControl", "minLength", "maxlength"], [1, "text-danger"]],
      template: function CfMobileNumberComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "label", 1);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 2)(5, "div", 3)(6, "mat-select", 4);
          i0.ɵɵlistener("selectionChange", function CfMobileNumberComponent_Template_mat_select_selectionChange_6_listener($event) {
            return ctx.changeDropdown($event);
          });
          i0.ɵɵelementStart(7, "mat-select-trigger");
          i0.ɵɵelement(8, "img", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, CfMobileNumberComponent_mat_option_9_Template, 5, 6, "mat-option", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(10, CfMobileNumberComponent_div_10_Template, 3, 1, "div", 7);
          i0.ɵɵelementStart(11, "div", 8);
          i0.ɵɵtemplate(12, CfMobileNumberComponent_span_12_Template, 2, 1, "span", 9)(13, CfMobileNumberComponent_input_13_Template, 1, 7, "input", 10);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(14, CfMobileNumberComponent_div_14_Template, 2, 1, "div", 11)(15, CfMobileNumberComponent_div_15_Template, 2, 1, "div", 11);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.label);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("error", ctx.inputControl.invalid && ctx.inputControl.touched || ctx.dialCodeControl.invalid && ctx.dialCodeControl.touched);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formControl", ctx.dialCodeControl);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("src", ctx.currentSelected.flagUrl, i0.ɵɵsanitizeUrl)("alt", ctx.currentSelected.countryName);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.options);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.currentSelected);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.inputControl.errors && ctx.inputControl.touched);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dialCodeControl.errors && ctx.dialCodeControl.touched && !ctx.inputControl.errors);
        }
      },
      dependencies: [i1$1.NgForOf, i1$1.NgIf, i5.DefaultValueAccessor, i5.NumberValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.MaxLengthValidator, i5.FormControlDirective, i5.FormGroupDirective, i3$1.MatSelect, i3$1.MatSelectTrigger, i4.MatOption],
      styles: [".cf-mobile-number[_ngcontent-%COMP%]{padding:0 1rem;height:max-content;margin-left:auto;margin-right:auto;margin-bottom:1rem}.cf-mobile-number[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{border:.5px solid #dc3545!important}.cf-mobile-number[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]   .dropdown-holder[_ngcontent-%COMP%]{border-right:1px solid #dc3545!important}.cf-mobile-number[_ngcontent-%COMP%]   .holder[_ngcontent-%COMP%]{border:.1px solid #f5f5f5;border-radius:9px;padding:.2rem .5rem;display:flex}.cf-mobile-number[_ngcontent-%COMP%]   .isd-code-holder[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.cf-mobile-number[_ngcontent-%COMP%]   .isd-code-holder[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:none;color:gray;padding-left:.5rem}.cf-mobile-number[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding-left:5px;width:100%}.cf-mobile-number[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:none}.cf-mobile-number[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:none;width:100%}.cf-mobile-number[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   .fa-copy[_ngcontent-%COMP%]{margin-left:1rem}.cf-mobile-number[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700;font-size:.8rem}.cf-mobile-number[_ngcontent-%COMP%]   .dropdown-holder[_ngcontent-%COMP%]{width:max-content;border-right:1px solid rgba(0,0,0,.1);padding-right:5px}@media only screen and (max-width: 500px){span[_ngcontent-%COMP%], input[_ngcontent-%COMP%], .label[_ngcontent-%COMP%]{font-size:1rem!important}}  .cf-mobile-number .mat-select-value{max-width:unset}input[_ngcontent-%COMP%]:focus, select[_ngcontent-%COMP%]:focus, textarea[_ngcontent-%COMP%]:focus, button[_ngcontent-%COMP%]:focus{outline:none}input[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:hover, input[_ngcontent-%COMP%]:-webkit-autofill:focus, input[_ngcontent-%COMP%]:-webkit-autofill:active{-webkit-box-shadow:0 0 0 30px white inset!important}input[_ngcontent-%COMP%]::-webkit-inner-spin-button, input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{appearance:textfield}"]
    });
  }
  return CfMobileNumberComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfMobileNumberModule = /*#__PURE__*/(() => {
  class CfMobileNumberModule {
    static ɵfac = function CfMobileNumberModule_Factory(t) {
      return new (t || CfMobileNumberModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfMobileNumberModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfMobileNumberModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfLoaderComponent = /*#__PURE__*/(() => {
  class CfLoaderComponent {
    diameter = 40;
    theme = 'dark';
    constructor() {}
    ngOnInit() {}
    static ɵfac = function CfLoaderComponent_Factory(t) {
      return new (t || CfLoaderComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfLoaderComponent,
      selectors: [["cf-loader"]],
      inputs: {
        diameter: "diameter",
        theme: "theme"
      },
      decls: 2,
      vars: 1,
      consts: [[1, "cf-loader"], [3, "diameter"]],
      template: function CfLoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "mat-spinner", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("diameter", ctx.diameter);
        }
      },
      dependencies: [i3.MatProgressSpinner],
      styles: [".cf-loader .mat-mdc-progress-spinner .mdc-circular-progress__circle-left svg{stroke:#cf0}  .cf-loader .mat-mdc-progress-spinner .mdc-circular-progress__circle-right svg{stroke:#000}"]
    });
  }
  return CfLoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfLoaderModule = /*#__PURE__*/(() => {
  class CfLoaderModule {
    static ɵfac = function CfLoaderModule_Factory(t) {
      return new (t || CfLoaderModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfLoaderModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfLoaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfOtpComponent = /*#__PURE__*/(() => {
  class CfOtpComponent {
    length = 6;
    changed = new EventEmitter();
    label = '';
    showLabel = true;
    prefillCode = '';
    theme = 'dark';
    numbers = [];
    otp = [];
    focus = [];
    allowedKeys;
    currentIndex = 0;
    width;
    window;
    platform = 'web';
    document = getDocument();
    constructor() {
      this.window = getWindow();
      this.width = this.window.outerWidth;
      if (this.width < 768) this.platform = 'mobile';
      const allowedKeys = ['Backspace', 'Digit0', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'KeyV', 'MetaLeft', 'MetaRight' // left command key in mac
      ];
      for (let i = 65; i <= 90; i++) allowedKeys.push(`Key${String.fromCharCode(i)}`);
      this.allowedKeys = new Set(allowedKeys);
    }
    onResize(event) {
      this.width = event.target.outerWidth;
      console.log('width on resize', this.width);
      if (this.width < 768) this.platform = 'mobile';
    }
    getInputId(index) {
      if (this.width < 768) return `cf-otp-input-mobile-${index}`;else return `cf-otp-input-web-${index}`;
    }
    ngOnInit() {
      this.numbers = Array.from({
        length: this.length
      }, (_, i) => i);
      this.otp = Array(this.length).fill('');
      this.changeInputFocus();
      if (this.prefillCode) this.prefillOtp(this.prefillCode);
    }
    prefillOtp(text, index = 0) {
      // const text = event.clipboardData?.getData('Text') || '';
      console.log('prefill', text);
      // const characters = text.split('').filter(char => /^[a-zA-Z0-9]$/.test(char)).slice(0, this.length - index);
      // const text = event.clipboardData?.getData('Text') || '';
      const characters = text.split('').filter(char => /^[a-zA-Z0-9]$/.test(char)).slice(0, this.length - index);
      // Update OTP array and the corresponding input fields
      characters.forEach((char, i) => {
        if (index + i < this.length) {
          this.setOtpArray(index + i, char);
          const input = this.document.getElementById(this.getInputId(index + i));
          if (input) input.value = char; // Directly set value
        }
      });
      // Update currentIndex and focus
      this.currentIndex = Math.min(index + characters.length, this.length - 1);
      this.changeInputFocus();
      // event.preventDefault();
    }
    handleKeyDown(event, index) {
      const allowed = this.allowedKeys.has(event.code);
      if (!allowed) event.preventDefault();
      return allowed;
    }
    handleKeyUp(event, index) {
      const currentKey = event.key;
      const isAlphanumeric = /^[a-zA-Z0-9]$/.test(currentKey);
      if (isAlphanumeric) {
        this.setOtpArray(index, currentKey);
        if (index < this.length - 1) {
          this.currentIndex = index + 1;
          this.changeInputFocus();
        }
      } else if (event.code === 'Backspace') {
        if (this.otp[index] !== '') {
          // Clear the current input value
          this.setOtpArray(index, '');
        } else if (index > 0) {
          // Move to the previous input field if the current field is empty
          this.currentIndex = index - 1;
          this.changeInputFocus();
          this.setOtpArray(this.currentIndex, ''); // Clear the previous field
        }
      }
    }
    handlePaste(event, index) {
      const text = event.clipboardData?.getData('Text') || '';
      const characters = text.split('').filter(char => /^[a-zA-Z0-9]$/.test(char)).slice(0, this.length - index);
      // Update OTP array and the corresponding input fields
      characters.forEach((char, i) => {
        if (index + i < this.length) {
          this.setOtpArray(index + i, char);
          const input = this.document.getElementById(this.getInputId(index + i));
          if (input) input.value = char; // Directly set value
        }
      });
      // Update currentIndex and focus
      this.currentIndex = Math.min(index + characters.length, this.length - 1);
      this.changeInputFocus();
      event.preventDefault();
    }
    changeInputFocus() {
      console.log('changeInputFocus', this.currentIndex);
      // Clear focus from all input fields
      this.focus.fill(false);
      // Ensure the currentIndex is within the valid range
      if (this.currentIndex >= 0 && this.currentIndex < this.length) {
        this.focus[this.currentIndex] = true;
        // Manually focus on the input element
        const id = this.getInputId(this.currentIndex);
        console.log('id', id);
        const inputElement = this.document.getElementById(id);
        console.log('inputElement', inputElement);
        if (inputElement) {
          inputElement.focus();
          // Set the cursor to the end of the input field if there's text
          if (inputElement.value.length > 0) {
            console.log('inputElement.value.length', inputElement.value.length);
            inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
          }
        }
      }
    }
    // setOtpArray(index: number, value: string): void {
    //     console.log('index', index, 'value', value);
    //     this.otp[index] = value;
    //     const validOtp = this.otp.join('');
    //     console.log('validOtp', validOtp);
    //     this.changed.emit(validOtp);
    // }
    setOtpArray(index, value) {
      console.log('setOtpArray index:', index, 'value:', value);
      if (index < 0 || index >= this.length) {
        console.error('Index out of bounds:', index);
        return;
      }
      console.log('index:', index, 'value:', value);
      // Update the OTP array
      this.otp[index] = value || '';
      // Emit the updated OTP
      const validOtp = this.otp.map(char => char || '').join('');
      console.log('validOtp:', validOtp);
      this.changed.emit(validOtp);
      // Optionally force Angular to detect changes
      // this.changeDetectorRef.detectChanges();
    }
    static ɵfac = function CfOtpComponent_Factory(t) {
      return new (t || CfOtpComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfOtpComponent,
      selectors: [["cf-otp"]],
      hostBindings: function CfOtpComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("resize", function CfOtpComponent_resize_HostBindingHandler($event) {
            return ctx.onResize($event);
          }, false, i0.ɵɵresolveWindow);
        }
      },
      inputs: {
        length: "length",
        label: "label",
        showLabel: "showLabel",
        prefillCode: "prefillCode",
        theme: "theme"
      },
      outputs: {
        changed: "changed"
      },
      decls: 5,
      vars: 2,
      consts: [[1, "cf-otp"], [1, "container-fluid"], ["class", "row", 4, "ngIf"], [1, "inputs"], ["class", "input-holder", 4, "ngFor", "ngForOf"], [1, "row"], [1, "col-md-12"], [1, "heading", 3, "ngClass"], [1, "input-holder"], ["type", "text", "autocomplete", "off", "maxlength", "1", "class", "web", 3, "autofocus", "ngClass", "id", "keydown", "keyup", "paste", 4, "ngIf"], ["type", "text", "autocomplete", "off", "maxlength", "1", "class", "mobile", 3, "autofocus", "ngClass", "id", "value", "keydown", "keyup", "paste", 4, "ngIf"], ["type", "text", "autocomplete", "off", "maxlength", "1", 1, "web", 3, "keydown", "keyup", "paste", "autofocus", "ngClass", "id"], ["type", "text", "autocomplete", "off", "maxlength", "1", 1, "mobile", 3, "keydown", "keyup", "paste", "autofocus", "ngClass", "id", "value"]],
      template: function CfOtpComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, CfOtpComponent_div_2_Template, 4, 2, "div", 2);
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtemplate(4, CfOtpComponent_div_4_Template, 3, 2, "div", 4);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.numbers);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf],
      styles: [".cf-otp[_ngcontent-%COMP%]{padding-left:1rem;padding-right:1rem}.cf-otp[_ngcontent-%COMP%]   .container-fluid[_ngcontent-%COMP%]{padding-left:0;padding-right:0}.cf-otp[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{font-weight:500;font-size:.8rem;padding-left:.5rem;display:flex}.cf-otp[_ngcontent-%COMP%]   .heading.dark[_ngcontent-%COMP%]{color:gray}.cf-otp[_ngcontent-%COMP%]   .heading.light[_ngcontent-%COMP%]{color:#000}.cf-otp[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]{display:flex}.cf-otp[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{font-weight:700}.cf-otp[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]{padding-left:.5rem;padding-right:.5rem}.cf-otp[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{padding:.4rem 0rem;justify-content:center;width:100%;line-height:2rem;text-align:center;border-radius:2px;font-size:1rem}.cf-otp[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input.dark[_ngcontent-%COMP%]{color:#d3d3d3;background-color:#1d1e22;border:.5px solid grey}.cf-otp[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-holder[_ngcontent-%COMP%]   input.light[_ngcontent-%COMP%]{color:#000;background-color:transparent;border:.1px solid #f5f5f5}input[_ngcontent-%COMP%]::-webkit-inner-spin-button, input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{appearance:textfield}@media only screen and (max-width: 768px){.heading[_ngcontent-%COMP%]{font-size:1rem!important}}.autofocus.dark[_ngcontent-%COMP%]{border:2px solid lightgrey!important}.autofocus.light[_ngcontent-%COMP%]{border:2px solid grey!important}"]
    });
  }
  return CfOtpComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfOtpModule = /*#__PURE__*/(() => {
  class CfOtpModule {
    static ɵfac = function CfOtpModule_Factory(t) {
      return new (t || CfOtpModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfOtpModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfOtpModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const animations$1 = [trigger('darkLight', [state('light', style({
  color: '#cf0'
})), state('dark', style({
  color: 'green'
})), transition('dark => light', [animate('1s')]), transition('light => dark', [animate('1s')])])];
let CfTickComponent = /*#__PURE__*/(() => {
  class CfTickComponent {
    size = 1.5;
    animation = true;
    toggle = true;
    setInervalId;
    constructor() {}
    ngOnInit() {
      if (this.animation) this.startAnimations();
    }
    startAnimations() {
      this.setInervalId = setInterval(() => {
        this.toggle = !this.toggle;
      }, 1000);
    }
    static ɵfac = function CfTickComponent_Factory(t) {
      return new (t || CfTickComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfTickComponent,
      selectors: [["cf-tick"]],
      inputs: {
        size: "size",
        animation: "animation"
      },
      decls: 2,
      vars: 4,
      consts: [[1, "cf-cross"], [1, "fa-solid", "fa-circle-check", 3, "ngStyle"]],
      template: function CfTickComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "i", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("@darkLight", ctx.toggle ? "dark" : "light")("ngStyle", i0.ɵɵpureFunction1(2, _c12, ctx.size + "rem"));
        }
      },
      dependencies: [i1$1.NgStyle],
      styles: [".cf-tick[_ngcontent-%COMP%]   .fa-circle-check[_ngcontent-%COMP%]{margin-right:.5rem}"],
      data: {
        animation: animations$1
      }
    });
  }
  return CfTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfTickModule = /*#__PURE__*/(() => {
  class CfTickModule {
    static ɵfac = function CfTickModule_Factory(t) {
      return new (t || CfTickModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfTickModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const animations = [trigger('darkLight', [state('light', style({
  color: '#a81313'
})), state('dark', style({
  color: 'red'
})), transition('dark => light', [animate('1s')]), transition('light => dark', [animate('1s')])])];
let CfCrossComponent = /*#__PURE__*/(() => {
  class CfCrossComponent {
    size = 1.5;
    animation = true;
    toggle = true;
    setInervalId;
    constructor() {}
    ngOnInit() {
      if (this.animation) this.startAnimations();
    }
    startAnimations() {
      this.setInervalId = setInterval(() => {
        this.toggle = !this.toggle;
      }, 1000);
    }
    static ɵfac = function CfCrossComponent_Factory(t) {
      return new (t || CfCrossComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfCrossComponent,
      selectors: [["cf-cross"]],
      inputs: {
        size: "size",
        animation: "animation"
      },
      decls: 2,
      vars: 4,
      consts: [[1, "cf-cross"], [1, "fa-solid", "fa-circle-xmark", 3, "ngStyle"]],
      template: function CfCrossComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "i", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("@darkLight", ctx.toggle ? "dark" : "light")("ngStyle", i0.ɵɵpureFunction1(2, _c12, ctx.size + "rem"));
        }
      },
      dependencies: [i1$1.NgStyle],
      styles: [".cf-cross[_ngcontent-%COMP%]   .fa-circle-xmark[_ngcontent-%COMP%]{margin-right:.5rem}"],
      data: {
        animation: animations
      }
    });
  }
  return CfCrossComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfCrossModule = /*#__PURE__*/(() => {
  class CfCrossModule {
    static ɵfac = function CfCrossModule_Factory(t) {
      return new (t || CfCrossModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfCrossModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return CfCrossModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfTabsComponent = /*#__PURE__*/(() => {
  class CfTabsComponent {
    tabs = [];
    changed = new EventEmitter();
    currentTab = '';
    theme = 'dark';
    constructor() {}
    ngOnInit() {}
    changeTab(tab) {
      this.currentTab = tab.value;
      this.changed.emit(tab);
    }
    static ɵfac = function CfTabsComponent_Factory(t) {
      return new (t || CfTabsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CfTabsComponent,
      selectors: [["cf-tabs"]],
      inputs: {
        tabs: "tabs",
        currentTab: "currentTab",
        theme: "theme"
      },
      outputs: {
        changed: "changed"
      },
      decls: 3,
      vars: 2,
      consts: [[1, "app-cf-tabs", "container-fluid", 3, "ngClass"], [1, "tabs"], ["class", "tab", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "tab", 3, "click", "ngClass"]],
      template: function CfTabsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, CfTabsComponent_span_2_Template, 2, 4, "span", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.theme);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.tabs);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf],
      styles: [".app-cf-tabs[_ngcontent-%COMP%]{padding:0}.app-cf-tabs[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]{display:flex;padding-bottom:.5rem;background-color:transparent;width:90%;overflow-x:auto;gap:1rem;margin-bottom:1rem}.app-cf-tabs[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]{padding:.2rem .5rem;background-color:transparent;width:max-content}.app-cf-tabs[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]:hover{cursor:pointer}.app-cf-tabs[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-active[_ngcontent-%COMP%]{font-weight:700;border-bottom-left-radius:11%;border-bottom-right-radius:11%;padding-bottom:.5rem}.app-cf-tabs.dark[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]{color:gray}.app-cf-tabs.dark[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-active[_ngcontent-%COMP%]{color:#fff;border-bottom:3px solid #cf0}.app-cf-tabs.light[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]{color:gray}.app-cf-tabs.light[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-active[_ngcontent-%COMP%]{color:#000;border-bottom:3px solid black}"]
    });
  }
  return CfTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CfTabsModule = /*#__PURE__*/(() => {
  class CfTabsModule {
    static ɵfac = function CfTabsModule_Factory(t) {
      return new (t || CfTabsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CfTabsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return CfTabsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UtilityFunctions = /*#__PURE__*/(() => {
  class UtilityFunctions {
    constructor() {}
    /** Validate the text passed */
    validateText(str, length, maxLength) {
      str = str ? str.toString() : '';
      if (str) {
        if (!str.trim() || str.trim() === '' || length && str.length < length || maxLength && str.length > maxLength) return false;
        return true;
      }
      return false;
    }
    // Required validator function
    requiredValidator(errorMessage) {
      return control => {
        const value = control.value;
        if (!value || !this.validateText(value)) {
          if (errorMessage) {
            return {
              required: errorMessage
            };
          } else {
            return {
              required: 'This field is required'
            };
          }
        }
        return null;
      };
    }
    // Required validator function
    maxlengthValidator(fieldName = '', length, input_type = 'string') {
      return control => {
        const value = control.value;
        if (value && !this.validateText(value, null, length)) {
          if (fieldName) {
            return {
              maxlength: `${fieldName} can't be greater than ${length} ${input_type === 'string' ? 'characters' : 'digits'}`
            };
          } else {
            return {
              maxlength: `Value can't be greater than ${length} ${input_type === 'string' ? 'characters' : 'digits'}`
            };
          }
        }
        return null;
      };
    }
    // Required validator function
    minlengthValidator(fieldName = '', length, input_type = 'string') {
      return control => {
        const value = control.value;
        if (value && !this.validateText(value, length)) {
          if (fieldName) {
            return {
              minlength: `${fieldName} can't be lesser than ${length} ${input_type === 'string' ? 'characters' : 'digits'}`
            };
          } else {
            return {
              minlength: `Value can't be lesser than ${length} ${input_type === 'string' ? 'characters' : 'digits'}`
            };
          }
        }
        return null;
      };
    }
    // Email form control validator function
    emailValidator = function (control) {
      const email = control.value;
      const regExp = /^([A-Za-z0-9_\-\.]+)@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,3})$/;
      if (email && !regExp.test(email)) {
        return {
          email: 'Please enter a valid email address'
        };
      }
      return null;
    };
    // Only numeric validator
    onlyNumber(errorMessage) {
      return control => {
        const value = control.value;
        const regExp = new RegExp('^[0-9]*$');
        if (value && !regExp.test(value)) {
          if (errorMessage) {
            return {
              onlyNumber: errorMessage
            };
          } else {
            return {
              onlyNumber: 'Please enter a valid number. Only numbers are allowed.'
            };
          }
        }
        return null;
      };
    }
    // Only alpha numeric hyphen validator
    password(errorMessage) {
      return control => {
        const regExp = new RegExp('^(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^&\*]{8,}$');
        const value = control.value;
        if (value && !regExp.test(value)) {
          if (errorMessage) {
            return {
              password: errorMessage
            };
          } else {
            return {
              password: 'Password must contain minimum 8 and maximum 50 characters, at least one uppercase letter, one lowercase letter, one number and one special character'
            };
          }
        }
        return null;
      };
    }
    //minimum value validation
    minValueValidator(fieldName, value) {
      return control => {
        const inputValue = control.value;
        if (inputValue && Number(inputValue) < Number(value)) {
          if (fieldName) {
            return {
              minvalue: `${fieldName} can't be lesser than ${value}`
            };
          } else {
            return {
              minvalue: `Value can't be lesser than ${value}`
            };
          }
        }
        return null;
      };
    }
    //maximum value validation
    maxValueValidator(fieldName, value) {
      return control => {
        const inputValue = control.value;
        if (inputValue && Number(inputValue) > Number(value)) {
          if (fieldName) {
            return {
              maxvalue: `${fieldName} can't be greater than ${value}`
            };
          } else {
            return {
              maxvalue: `Value can't be greater than ${value}`
            };
          }
        }
        return null;
      };
    }
    //patern validator
    patternValidator(regex, fieldName, errorMessage) {
      return control => {
        const regExp = new RegExp(regex);
        const value = control.value;
        if (value && !regExp.test(value)) {
          if (errorMessage) {
            return {
              pattern: errorMessage
            };
          } else if (fieldName) {
            return {
              pattern: `Please enter valid ${fieldName}`
            };
          } else {
            return {
              pattern: 'Please enter valid pattern'
            };
          }
        }
        return null;
      };
    }
    static ɵfac = function UtilityFunctions_Factory(t) {
      return new (t || UtilityFunctions)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UtilityFunctions,
      factory: UtilityFunctions.ɵfac,
      providedIn: 'root'
    });
  }
  return UtilityFunctions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of credible-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CfAlertModule, CfAlertService, CfButtonComponent, CfButtonModule, CfCardComponent, CfCardModule, CfCheckboxComponent, CfCheckboxLargeComponent, CfCheckboxLargeModule, CfCheckboxModule, CfChipComponent, CfChipModule, CfCircularProgressBarComponent, CfCircularProgressBarModule, CfCircularTimerProgressComponent, CfCircularTimerProgressModule, CfCrossComponent, CfCrossModule, CfDropdownComponent, CfDropdownModule, CfInputComponent, CfInputCurrencyComponent, CfInputCurrencyDropdownComponent, CfInputCurrencyDropdownModule, CfInputCurrencyModule, CfInputModule, CfLoaderComponent, CfLoaderModule, CfMobileNumberComponent, CfMobileNumberModule, CfOtpComponent, CfOtpModule, CfPaginatorComponent, CfPaginatorModule, CfProgressBarComponent, CfProgressBarModule, CfRedirectComponent, CfRedirectModule, CfTabsComponent, CfTabsModule, CfTickComponent, CfTickModule, CfToggleComponent, CfToggleModule, CfVerticalProgressBarComponent, CfVerticalProgressBarModule, UtilityFunctions };
